var items = {
  "block.minecraft.acacia_button": "Akáciové tlačítko",
  "block.minecraft.acacia_door": "Akáciové dveře",
  "block.minecraft.acacia_fence": "Akáciový plot",
  "block.minecraft.acacia_fence_gate": "Akáciová branka",
  "block.minecraft.acacia_hanging_sign": "Akáciová závěsná cedule",
  "block.minecraft.acacia_leaves": "Akáciové listí",
  "block.minecraft.acacia_log": "Akáciový kmen",
  "block.minecraft.acacia_planks": "Akáciová prkna",
  "block.minecraft.acacia_pressure_plate": "Akáciová nášlapná deska",
  "block.minecraft.acacia_sapling": "Sazenice akácie",
  "block.minecraft.acacia_shelf": "Akáciová polička",
  "block.minecraft.acacia_sign": "Akáciová cedule",
  "block.minecraft.acacia_slab": "Akáciový půlblok",
  "block.minecraft.acacia_stairs": "Akáciové schody",
  "block.minecraft.acacia_trapdoor": "Akáciový poklop",
  "block.minecraft.acacia_wall_hanging_sign": "Akáciová závěsná cedule na zdi",
  "block.minecraft.acacia_wall_sign": "Akáciová cedule na zdi",
  "block.minecraft.acacia_wood": "Akáciové dřevo",
  "block.minecraft.activator_rail": "Aktivační kolej",
  "block.minecraft.air": "Vzduch",
  "block.minecraft.allium": "Česnek",
  "block.minecraft.amethyst_block": "Ametystový blok",
  "block.minecraft.amethyst_cluster": "Ametystová drúza",
  "block.minecraft.ancient_debris": "Prastará suť",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Andezitový půlblok",
  "block.minecraft.andesite_stairs": "Andezitové schody",
  "block.minecraft.andesite_wall": "Andezitová zídka",
  "block.minecraft.anvil": "Kovadlina",
  "block.minecraft.attached_melon_stem": "Připojený melounový stonek",
  "block.minecraft.attached_pumpkin_stem": "Připojený dýňový stonek",
  "block.minecraft.azalea": "Azalka",
  "block.minecraft.azalea_leaves": "Listí azalky",
  "block.minecraft.azure_bluet": "Houstonie modrá",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusový blok",
  "block.minecraft.bamboo_button": "Bambusové tlačítko",
  "block.minecraft.bamboo_door": "Bambusové dveře",
  "block.minecraft.bamboo_fence": "Bambusový plot",
  "block.minecraft.bamboo_fence_gate": "Bambusová branka",
  "block.minecraft.bamboo_hanging_sign": "Bambusová závěsná cedule",
  "block.minecraft.bamboo_mosaic": "Bambusová mozaika",
  "block.minecraft.bamboo_mosaic_slab": "Půlblok z bambusové mozaiky",
  "block.minecraft.bamboo_mosaic_stairs": "Schody z bambusové mozaiky",
  "block.minecraft.bamboo_planks": "Bambusová prkna",
  "block.minecraft.bamboo_pressure_plate": "Bambusová nášlapná deska",
  "block.minecraft.bamboo_sapling": "Bambusový výhonek",
  "block.minecraft.bamboo_shelf": "Bambusová polička",
  "block.minecraft.bamboo_sign": "Bambusová cedule",
  "block.minecraft.bamboo_slab": "Bambusový půlblok",
  "block.minecraft.bamboo_stairs": "Bambusové schody",
  "block.minecraft.bamboo_trapdoor": "Bambusový poklop",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambusová závěsná cedule na zdi",
  "block.minecraft.bamboo_wall_sign": "Bambusová cedule na zdi",
  "block.minecraft.banner.base.black": "Černý list",
  "block.minecraft.banner.base.blue": "Modrý list",
  "block.minecraft.banner.base.brown": "Hnědý list",
  "block.minecraft.banner.base.cyan": "Azurový list",
  "block.minecraft.banner.base.gray": "Šedý list",
  "block.minecraft.banner.base.green": "Zelený list",
  "block.minecraft.banner.base.light_blue": "Světle modrý list",
  "block.minecraft.banner.base.light_gray": "Světle šedý list",
  "block.minecraft.banner.base.lime": "Světle zelený list",
  "block.minecraft.banner.base.magenta": "Purpurový list",
  "block.minecraft.banner.base.orange": "Oranžový list",
  "block.minecraft.banner.base.pink": "Růžový list",
  "block.minecraft.banner.base.purple": "Fialový list",
  "block.minecraft.banner.base.red": "Červený list",
  "block.minecraft.banner.base.white": "Bílý list",
  "block.minecraft.banner.base.yellow": "Žlutý list",
  "block.minecraft.banner.border.black": "Černý lem",
  "block.minecraft.banner.border.blue": "Modrý lem",
  "block.minecraft.banner.border.brown": "Hnědý lem",
  "block.minecraft.banner.border.cyan": "Azurový lem",
  "block.minecraft.banner.border.gray": "Šedý lem",
  "block.minecraft.banner.border.green": "Zelený lem",
  "block.minecraft.banner.border.light_blue": "Světle modrý lem",
  "block.minecraft.banner.border.light_gray": "Světle šedý lem",
  "block.minecraft.banner.border.lime": "Světle zelený lem",
  "block.minecraft.banner.border.magenta": "Purpurový lem",
  "block.minecraft.banner.border.orange": "Oranžový lem",
  "block.minecraft.banner.border.pink": "Růžový lem",
  "block.minecraft.banner.border.purple": "Fialový lem",
  "block.minecraft.banner.border.red": "Červený lem",
  "block.minecraft.banner.border.white": "Bílý lem",
  "block.minecraft.banner.border.yellow": "Žlutý lem",
  "block.minecraft.banner.bricks.black": "Černá cihlová vazba",
  "block.minecraft.banner.bricks.blue": "Modrá cihlová vazba",
  "block.minecraft.banner.bricks.brown": "Hnědá cihlová vazba",
  "block.minecraft.banner.bricks.cyan": "Azurová cihlová vazba",
  "block.minecraft.banner.bricks.gray": "Šedá cihlová vazba",
  "block.minecraft.banner.bricks.green": "Zelená cihlová vazba",
  "block.minecraft.banner.bricks.light_blue": "Světle modrá cihlová vazba",
  "block.minecraft.banner.bricks.light_gray": "Světle šedá cihlová vazba",
  "block.minecraft.banner.bricks.lime": "Světle zelená cihlová vazba",
  "block.minecraft.banner.bricks.magenta": "Purpurová cihlová vazba",
  "block.minecraft.banner.bricks.orange": "Oranžová cihlová vazba",
  "block.minecraft.banner.bricks.pink": "Růžová cihlová vazba",
  "block.minecraft.banner.bricks.purple": "Fialová cihlová vazba",
  "block.minecraft.banner.bricks.red": "Červená cihlová vazba",
  "block.minecraft.banner.bricks.white": "Bílá cihlová vazba",
  "block.minecraft.banner.bricks.yellow": "Žlutá cihlová vazba",
  "block.minecraft.banner.circle.black": "Černý kotouč",
  "block.minecraft.banner.circle.blue": "Modrý kotouč",
  "block.minecraft.banner.circle.brown": "Hnědý kotouč",
  "block.minecraft.banner.circle.cyan": "Azurový kotouč",
  "block.minecraft.banner.circle.gray": "Šedý kotouč",
  "block.minecraft.banner.circle.green": "Zelený kotouč",
  "block.minecraft.banner.circle.light_blue": "Světle modrý kotouč",
  "block.minecraft.banner.circle.light_gray": "Světle šedý kotouč",
  "block.minecraft.banner.circle.lime": "Světle zelený kotouč",
  "block.minecraft.banner.circle.magenta": "Purpurový kotouč",
  "block.minecraft.banner.circle.orange": "Oranžový kotouč",
  "block.minecraft.banner.circle.pink": "Růžový kotouč",
  "block.minecraft.banner.circle.purple": "Fialový kotouč",
  "block.minecraft.banner.circle.red": "Červený kotouč",
  "block.minecraft.banner.circle.white": "Bílý kotouč",
  "block.minecraft.banner.circle.yellow": "Žlutý kotouč",
  "block.minecraft.banner.creeper.black": "Černá tvář creepera",
  "block.minecraft.banner.creeper.blue": "Modrá tvář creepera",
  "block.minecraft.banner.creeper.brown": "Hnědá tvář creepera",
  "block.minecraft.banner.creeper.cyan": "Azurová tvář creepera",
  "block.minecraft.banner.creeper.gray": "Šedá tvář creepera",
  "block.minecraft.banner.creeper.green": "Zelená tvář creepera",
  "block.minecraft.banner.creeper.light_blue": "Světle modrá tvář creepera",
  "block.minecraft.banner.creeper.light_gray": "Světle šedá tvář creepera",
  "block.minecraft.banner.creeper.lime": "Světle zelená tvář creepera",
  "block.minecraft.banner.creeper.magenta": "Purpurová tvář creepera",
  "block.minecraft.banner.creeper.orange": "Oranžová tvář creepera",
  "block.minecraft.banner.creeper.pink": "Růžová tvář creepera",
  "block.minecraft.banner.creeper.purple": "Fialová tvář creepera",
  "block.minecraft.banner.creeper.red": "Červená tvář creepera",
  "block.minecraft.banner.creeper.white": "Bílá tvář creepera",
  "block.minecraft.banner.creeper.yellow": "Žlutá tvář creepera",
  "block.minecraft.banner.cross.black": "Černý ondřejský kříž",
  "block.minecraft.banner.cross.blue": "Modrý ondřejský kříž",
  "block.minecraft.banner.cross.brown": "Hnědý ondřejský kříž",
  "block.minecraft.banner.cross.cyan": "Azurový ondřejský kříž",
  "block.minecraft.banner.cross.gray": "Šedý ondřejský kříž",
  "block.minecraft.banner.cross.green": "Zelený ondřejský kříž",
  "block.minecraft.banner.cross.light_blue": "Světle modrý ondřejský kříž",
  "block.minecraft.banner.cross.light_gray": "Světle šedý ondřejský kříž",
  "block.minecraft.banner.cross.lime": "Světle zelený ondřejský kříž",
  "block.minecraft.banner.cross.magenta": "Purpurový ondřejský kříž",
  "block.minecraft.banner.cross.orange": "Oranžový ondřejský kříž",
  "block.minecraft.banner.cross.pink": "Růžový ondřejský kříž",
  "block.minecraft.banner.cross.purple": "Fialový ondřejský kříž",
  "block.minecraft.banner.cross.red": "Červený ondřejský kříž",
  "block.minecraft.banner.cross.white": "Bílý ondřejský kříž",
  "block.minecraft.banner.cross.yellow": "Žlutý ondřejský kříž",
  "block.minecraft.banner.curly_border.black": "Černá bordura",
  "block.minecraft.banner.curly_border.blue": "Modrá bordura",
  "block.minecraft.banner.curly_border.brown": "Hnědá bordura",
  "block.minecraft.banner.curly_border.cyan": "Azurová bordura",
  "block.minecraft.banner.curly_border.gray": "Šedá bordura",
  "block.minecraft.banner.curly_border.green": "Zelená bordura",
  "block.minecraft.banner.curly_border.light_blue": "Světle modrá bordura",
  "block.minecraft.banner.curly_border.light_gray": "Světle šedá bordura",
  "block.minecraft.banner.curly_border.lime": "Světle zelená bordura",
  "block.minecraft.banner.curly_border.magenta": "Purpurová bordura",
  "block.minecraft.banner.curly_border.orange": "Oranžová bordura",
  "block.minecraft.banner.curly_border.pink": "Růžová bordura",
  "block.minecraft.banner.curly_border.purple": "Fialová bordura",
  "block.minecraft.banner.curly_border.red": "Červená bordura",
  "block.minecraft.banner.curly_border.white": "Bílá bordura",
  "block.minecraft.banner.curly_border.yellow": "Žlutá bordura",
  "block.minecraft.banner.diagonal_left.black": "Černé horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.blue": "Modré horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.brown": "Hnědé horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.cyan": "Azurové horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.gray": "Šedé horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.green": "Zelené horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.light_blue": "Světle modré horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.light_gray": "Světle šedé horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.lime": "Světle zelené horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.magenta": "Purpurové horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.orange": "Oranžové horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.pink": "Růžové horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.purple": "Fialové horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.red": "Červené horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.white": "Bílé horní šikmé dělení",
  "block.minecraft.banner.diagonal_left.yellow": "Žluté horní šikmé dělení",
  "block.minecraft.banner.diagonal_right.black": "Černé horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.blue": "Modré horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.brown": "Hnědé horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.cyan": "Azurové horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.gray": "Šedé horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.green": "Zelené horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.light_blue": "Světle modré horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.light_gray": "Světle šedé horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.lime": "Světle zelené horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.magenta": "Purpurové horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.orange": "Oranžové horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.pink": "Růžové horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.purple": "Fialové horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.red": "Červené horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.white": "Bílé horní kosmé dělení",
  "block.minecraft.banner.diagonal_right.yellow": "Žluté horní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.black": "Černé dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.blue": "Modré dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.brown": "Hnědé dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.cyan": "Azurové dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.gray": "Šedé dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.green": "Zelené dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Světle modré dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Světle šedé dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.lime": "Světle zelené dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.magenta": "Purpurové dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranžové dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.pink": "Růžové dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.purple": "Fialové dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.red": "Červené dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.white": "Bílé dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_left.yellow": "Žluté dolní kosmé dělení",
  "block.minecraft.banner.diagonal_up_right.black": "Černé dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.blue": "Modré dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.brown": "Hnědé dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.cyan": "Azurové dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.gray": "Šedé dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.green": "Zelené dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Světle modré dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Světle šedé dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.lime": "Světle zelené dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.magenta": "Purpurové dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranžové dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.pink": "Růžové dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.purple": "Fialové dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.red": "Červené dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.white": "Bílé dolní šikmé dělení",
  "block.minecraft.banner.diagonal_up_right.yellow": "Žluté dolní šikmé dělení",
  "block.minecraft.banner.flow.black": "Černý vír",
  "block.minecraft.banner.flow.blue": "Modrý vír",
  "block.minecraft.banner.flow.brown": "Hnědý vír",
  "block.minecraft.banner.flow.cyan": "Azurový vír",
  "block.minecraft.banner.flow.gray": "Šedý vír",
  "block.minecraft.banner.flow.green": "Zelený vír",
  "block.minecraft.banner.flow.light_blue": "Světle modrý vír",
  "block.minecraft.banner.flow.light_gray": "Světle šedý vír",
  "block.minecraft.banner.flow.lime": "Světle zelený vír",
  "block.minecraft.banner.flow.magenta": "Purpurový vír",
  "block.minecraft.banner.flow.orange": "Oranžový vír",
  "block.minecraft.banner.flow.pink": "Růžový vír",
  "block.minecraft.banner.flow.purple": "Fialový vír",
  "block.minecraft.banner.flow.red": "Červený vír",
  "block.minecraft.banner.flow.white": "Bílý vír",
  "block.minecraft.banner.flow.yellow": "Žlutý vír",
  "block.minecraft.banner.flower.black": "Černý květ",
  "block.minecraft.banner.flower.blue": "Modrý květ",
  "block.minecraft.banner.flower.brown": "Hnědý květ",
  "block.minecraft.banner.flower.cyan": "Azurový květ",
  "block.minecraft.banner.flower.gray": "Šedý květ",
  "block.minecraft.banner.flower.green": "Zelený květ",
  "block.minecraft.banner.flower.light_blue": "Světle modrý květ",
  "block.minecraft.banner.flower.light_gray": "Světle šedý květ",
  "block.minecraft.banner.flower.lime": "Světle zelený květ",
  "block.minecraft.banner.flower.magenta": "Purpurový květ",
  "block.minecraft.banner.flower.orange": "Oranžový květ",
  "block.minecraft.banner.flower.pink": "Růžový květ",
  "block.minecraft.banner.flower.purple": "Fialový květ",
  "block.minecraft.banner.flower.red": "Červený květ",
  "block.minecraft.banner.flower.white": "Bílý květ",
  "block.minecraft.banner.flower.yellow": "Žlutý květ",
  "block.minecraft.banner.globe.black": "Černá zeměkostka",
  "block.minecraft.banner.globe.blue": "Modrá zeměkostka",
  "block.minecraft.banner.globe.brown": "Hnědá zeměkostka",
  "block.minecraft.banner.globe.cyan": "Azurová zeměkostka",
  "block.minecraft.banner.globe.gray": "Šedá zeměkostka",
  "block.minecraft.banner.globe.green": "Zelená zeměkostka",
  "block.minecraft.banner.globe.light_blue": "Světle modrá zeměkostka",
  "block.minecraft.banner.globe.light_gray": "Světle šedá zeměkostka",
  "block.minecraft.banner.globe.lime": "Světle zelená zeměkostka",
  "block.minecraft.banner.globe.magenta": "Purpurová zeměkostka",
  "block.minecraft.banner.globe.orange": "Oranžová zeměkostka",
  "block.minecraft.banner.globe.pink": "Růžová zeměkostka",
  "block.minecraft.banner.globe.purple": "Fialová zeměkostka",
  "block.minecraft.banner.globe.red": "Červená zeměkostka",
  "block.minecraft.banner.globe.white": "Bílá zeměkostka",
  "block.minecraft.banner.globe.yellow": "Žlutá zeměkostka",
  "block.minecraft.banner.gradient.black": "Černý gradient shora dolů",
  "block.minecraft.banner.gradient.blue": "Modrý gradient shora dolů",
  "block.minecraft.banner.gradient.brown": "Hnědý gradient shora dolů",
  "block.minecraft.banner.gradient.cyan": "Azurový gradient shora dolů",
  "block.minecraft.banner.gradient.gray": "Šedý gradient shora dolů",
  "block.minecraft.banner.gradient.green": "Zelený gradient shora dolů",
  "block.minecraft.banner.gradient.light_blue": "Světle modrý gradient shora dolů",
  "block.minecraft.banner.gradient.light_gray": "Světle šedý gradient shora dolů",
  "block.minecraft.banner.gradient.lime": "Světle zelený gradient shora dolů",
  "block.minecraft.banner.gradient.magenta": "Purpurový gradient shora dolů",
  "block.minecraft.banner.gradient.orange": "Oranžový gradient shora dolů",
  "block.minecraft.banner.gradient.pink": "Růžový gradient shora dolů",
  "block.minecraft.banner.gradient.purple": "Fialový gradient shora dolů",
  "block.minecraft.banner.gradient.red": "Červený gradient shora dolů",
  "block.minecraft.banner.gradient.white": "Bílý gradient shora dolů",
  "block.minecraft.banner.gradient.yellow": "Žlutý gradient shora dolů",
  "block.minecraft.banner.gradient_up.black": "Černý gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.blue": "Modrý gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.brown": "Hnědý gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.cyan": "Azurový gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.gray": "Šedý gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.green": "Zelený gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.light_blue": "Světle modrý gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.light_gray": "Světle šedý gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.lime": "Světle zelený gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.magenta": "Purpurový gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.orange": "Oranžový gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.pink": "Růžový gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.purple": "Fialový gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.red": "Červený gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.white": "Bílý gradient zdola nahoru",
  "block.minecraft.banner.gradient_up.yellow": "Žlutý gradient zdola nahoru",
  "block.minecraft.banner.guster.black": "Černá smršť",
  "block.minecraft.banner.guster.blue": "Modrá smršť",
  "block.minecraft.banner.guster.brown": "Hnědá smršť",
  "block.minecraft.banner.guster.cyan": "Azurová smršť",
  "block.minecraft.banner.guster.gray": "Šedá smršť",
  "block.minecraft.banner.guster.green": "Zelená smršť",
  "block.minecraft.banner.guster.light_blue": "Světle modrá smršť",
  "block.minecraft.banner.guster.light_gray": "Světle šedá smršť",
  "block.minecraft.banner.guster.lime": "Světle zelená smršť",
  "block.minecraft.banner.guster.magenta": "Purpurová smršť",
  "block.minecraft.banner.guster.orange": "Oranžová smršť",
  "block.minecraft.banner.guster.pink": "Růžová smršť",
  "block.minecraft.banner.guster.purple": "Fialová smršť",
  "block.minecraft.banner.guster.red": "Červená smršť",
  "block.minecraft.banner.guster.white": "Bílá smršť",
  "block.minecraft.banner.guster.yellow": "Žlutá smršť",
  "block.minecraft.banner.half_horizontal.black": "Černé horní dělení",
  "block.minecraft.banner.half_horizontal.blue": "Modré horní dělení",
  "block.minecraft.banner.half_horizontal.brown": "Hnědé horní dělení",
  "block.minecraft.banner.half_horizontal.cyan": "Azurové horní dělení",
  "block.minecraft.banner.half_horizontal.gray": "Šedé horní dělení",
  "block.minecraft.banner.half_horizontal.green": "Zelené horní dělení",
  "block.minecraft.banner.half_horizontal.light_blue": "Světle modré horní dělení",
  "block.minecraft.banner.half_horizontal.light_gray": "Světle šedé horní dělení",
  "block.minecraft.banner.half_horizontal.lime": "Světle zelené horní dělení",
  "block.minecraft.banner.half_horizontal.magenta": "Purpurové horní dělení",
  "block.minecraft.banner.half_horizontal.orange": "Oranžové horní dělení",
  "block.minecraft.banner.half_horizontal.pink": "Růžové horní dělení",
  "block.minecraft.banner.half_horizontal.purple": "Fialové horní dělení",
  "block.minecraft.banner.half_horizontal.red": "Červené horní dělení",
  "block.minecraft.banner.half_horizontal.white": "Bílé horní dělení",
  "block.minecraft.banner.half_horizontal.yellow": "Žluté horní dělení",
  "block.minecraft.banner.half_horizontal_bottom.black": "Černé dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Modré dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Hnědé dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Azurové dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Šedé dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zelené dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Světle modré dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Světle šedé dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Světle zelené dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Purpurové dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranžové dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Růžové dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Fialové dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.red": "Červené dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.white": "Bílé dolní dělení",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Žluté dolní dělení",
  "block.minecraft.banner.half_vertical.black": "Černé pravé půlení",
  "block.minecraft.banner.half_vertical.blue": "Modré pravé půlení",
  "block.minecraft.banner.half_vertical.brown": "Hnědé pravé půlení",
  "block.minecraft.banner.half_vertical.cyan": "Azurové pravé půlení",
  "block.minecraft.banner.half_vertical.gray": "Šedé pravé půlení",
  "block.minecraft.banner.half_vertical.green": "Zelené pravé půlení",
  "block.minecraft.banner.half_vertical.light_blue": "Světle modré pravé půlení",
  "block.minecraft.banner.half_vertical.light_gray": "Světle šedé pravé půlení",
  "block.minecraft.banner.half_vertical.lime": "Světle zelené pravé půlení",
  "block.minecraft.banner.half_vertical.magenta": "Purpurové pravé půlení",
  "block.minecraft.banner.half_vertical.orange": "Oranžové pravé půlení",
  "block.minecraft.banner.half_vertical.pink": "Růžové pravé půlení",
  "block.minecraft.banner.half_vertical.purple": "Fialové pravé půlení",
  "block.minecraft.banner.half_vertical.red": "Červené pravé půlení",
  "block.minecraft.banner.half_vertical.white": "Bílé pravé půlení",
  "block.minecraft.banner.half_vertical.yellow": "Žluté pravé půlení",
  "block.minecraft.banner.half_vertical_right.black": "Černé levé půlení",
  "block.minecraft.banner.half_vertical_right.blue": "Modré levé půlení",
  "block.minecraft.banner.half_vertical_right.brown": "Hnědé levé půlení",
  "block.minecraft.banner.half_vertical_right.cyan": "Azurové levé půlení",
  "block.minecraft.banner.half_vertical_right.gray": "Šedé levé půlení",
  "block.minecraft.banner.half_vertical_right.green": "Zelené levé půlení",
  "block.minecraft.banner.half_vertical_right.light_blue": "Světle modré levé půlení",
  "block.minecraft.banner.half_vertical_right.light_gray": "Světle šedé levé půlení",
  "block.minecraft.banner.half_vertical_right.lime": "Světle zelené levé půlení",
  "block.minecraft.banner.half_vertical_right.magenta": "Purpurové levé půlení",
  "block.minecraft.banner.half_vertical_right.orange": "Oranžové levé půlení",
  "block.minecraft.banner.half_vertical_right.pink": "Růžové levé půlení",
  "block.minecraft.banner.half_vertical_right.purple": "Fialové levé půlení",
  "block.minecraft.banner.half_vertical_right.red": "Červené levé půlení",
  "block.minecraft.banner.half_vertical_right.white": "Bílé levé půlení",
  "block.minecraft.banner.half_vertical_right.yellow": "Žluté levé půlení",
  "block.minecraft.banner.mojang.black": "Černý znak",
  "block.minecraft.banner.mojang.blue": "Modrý znak",
  "block.minecraft.banner.mojang.brown": "Hnědý znak",
  "block.minecraft.banner.mojang.cyan": "Azurový znak",
  "block.minecraft.banner.mojang.gray": "Šedý znak",
  "block.minecraft.banner.mojang.green": "Zelený znak",
  "block.minecraft.banner.mojang.light_blue": "Světle modrý znak",
  "block.minecraft.banner.mojang.light_gray": "Světle šedý znak",
  "block.minecraft.banner.mojang.lime": "Světle zelený znak",
  "block.minecraft.banner.mojang.magenta": "Purpurový znak",
  "block.minecraft.banner.mojang.orange": "Oranžový znak",
  "block.minecraft.banner.mojang.pink": "Růžový znak",
  "block.minecraft.banner.mojang.purple": "Fialový znak",
  "block.minecraft.banner.mojang.red": "Červený znak",
  "block.minecraft.banner.mojang.white": "Bílý znak",
  "block.minecraft.banner.mojang.yellow": "Žlutý znak",
  "block.minecraft.banner.piglin.black": "Černý rypák",
  "block.minecraft.banner.piglin.blue": "Modrý rypák",
  "block.minecraft.banner.piglin.brown": "Hnědý rypák",
  "block.minecraft.banner.piglin.cyan": "Azurový rypák",
  "block.minecraft.banner.piglin.gray": "Šedý rypák",
  "block.minecraft.banner.piglin.green": "Zelený rypák",
  "block.minecraft.banner.piglin.light_blue": "Světle modrý rypák",
  "block.minecraft.banner.piglin.light_gray": "Světle šedý rypák",
  "block.minecraft.banner.piglin.lime": "Světle zelený rypák",
  "block.minecraft.banner.piglin.magenta": "Purpurový rypák",
  "block.minecraft.banner.piglin.orange": "Oranžový rypák",
  "block.minecraft.banner.piglin.pink": "Růžový rypák",
  "block.minecraft.banner.piglin.purple": "Fialový rypák",
  "block.minecraft.banner.piglin.red": "Červený rypák",
  "block.minecraft.banner.piglin.white": "Bílý rypák",
  "block.minecraft.banner.piglin.yellow": "Žlutý rypák",
  "block.minecraft.banner.rhombus.black": "Černá routa",
  "block.minecraft.banner.rhombus.blue": "Modrá routa",
  "block.minecraft.banner.rhombus.brown": "Hnědá routa",
  "block.minecraft.banner.rhombus.cyan": "Azurová routa",
  "block.minecraft.banner.rhombus.gray": "Šedá routa",
  "block.minecraft.banner.rhombus.green": "Zelená routa",
  "block.minecraft.banner.rhombus.light_blue": "Světle modrá routa",
  "block.minecraft.banner.rhombus.light_gray": "Světle šedá routa",
  "block.minecraft.banner.rhombus.lime": "Světle zelená routa",
  "block.minecraft.banner.rhombus.magenta": "Purpurová routa",
  "block.minecraft.banner.rhombus.orange": "Oranžová routa",
  "block.minecraft.banner.rhombus.pink": "Růžová routa",
  "block.minecraft.banner.rhombus.purple": "Fialová routa",
  "block.minecraft.banner.rhombus.red": "Červená routa",
  "block.minecraft.banner.rhombus.white": "Bílá routa",
  "block.minecraft.banner.rhombus.yellow": "Žlutá routa",
  "block.minecraft.banner.skull.black": "Černá lebka",
  "block.minecraft.banner.skull.blue": "Modrá lebka",
  "block.minecraft.banner.skull.brown": "Hnědá lebka",
  "block.minecraft.banner.skull.cyan": "Azurová lebka",
  "block.minecraft.banner.skull.gray": "Šedá lebka",
  "block.minecraft.banner.skull.green": "Zelená lebka",
  "block.minecraft.banner.skull.light_blue": "Světle modrá lebka",
  "block.minecraft.banner.skull.light_gray": "Světle šedá lebka",
  "block.minecraft.banner.skull.lime": "Světle zelená lebka",
  "block.minecraft.banner.skull.magenta": "Purpurová lebka",
  "block.minecraft.banner.skull.orange": "Oranžová lebka",
  "block.minecraft.banner.skull.pink": "Růžová lebka",
  "block.minecraft.banner.skull.purple": "Fialová lebka",
  "block.minecraft.banner.skull.red": "Červená lebka",
  "block.minecraft.banner.skull.white": "Bílá lebka",
  "block.minecraft.banner.skull.yellow": "Žlutá lebka",
  "block.minecraft.banner.small_stripes.black": "Černé kůly",
  "block.minecraft.banner.small_stripes.blue": "Modré kůly",
  "block.minecraft.banner.small_stripes.brown": "Hnědé kůly",
  "block.minecraft.banner.small_stripes.cyan": "Azurové kůly",
  "block.minecraft.banner.small_stripes.gray": "Šedé kůly",
  "block.minecraft.banner.small_stripes.green": "Zelené kůly",
  "block.minecraft.banner.small_stripes.light_blue": "Světle modré kůly",
  "block.minecraft.banner.small_stripes.light_gray": "Světle šedé kůly",
  "block.minecraft.banner.small_stripes.lime": "Světle zelené kůly",
  "block.minecraft.banner.small_stripes.magenta": "Purpurové kůly",
  "block.minecraft.banner.small_stripes.orange": "Oranžové kůly",
  "block.minecraft.banner.small_stripes.pink": "Růžové kůly",
  "block.minecraft.banner.small_stripes.purple": "Fialové kůly",
  "block.minecraft.banner.small_stripes.red": "Červené kůly",
  "block.minecraft.banner.small_stripes.white": "Bílé kůly",
  "block.minecraft.banner.small_stripes.yellow": "Žluté kůly",
  "block.minecraft.banner.square_bottom_left.black": "Černá dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.blue": "Modrá dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.brown": "Hnědá dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.cyan": "Azurová dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.gray": "Šedá dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.green": "Zelená dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.light_blue": "Světle modrá dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.light_gray": "Světle šedá dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.lime": "Světle zelená dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.magenta": "Purpurová dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.orange": "Oranžová dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.pink": "Růžová dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.purple": "Fialová dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.red": "Červená dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.white": "Bílá dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_left.yellow": "Žlutá dolní pravá čtvrť",
  "block.minecraft.banner.square_bottom_right.black": "Černá dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.blue": "Modrá dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.brown": "Hnědá dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.cyan": "Azurová dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.gray": "Šedá dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.green": "Zelená dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.light_blue": "Světle modrá dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.light_gray": "Světle šedá dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.lime": "Světle zelená dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.magenta": "Purpurová dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.orange": "Oranžová dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.pink": "Růžová dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.purple": "Fialová dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.red": "Červená dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.white": "Bílá dolní levá čtvrť",
  "block.minecraft.banner.square_bottom_right.yellow": "Žlutá dolní levá čtvrť",
  "block.minecraft.banner.square_top_left.black": "Černá horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.blue": "Modrá horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.brown": "Hnědá horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.cyan": "Azurová horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.gray": "Šedá horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.green": "Zelená horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.light_blue": "Světle modrá horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.light_gray": "Světle šedá horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.lime": "Světle zelená horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.magenta": "Purpurová horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.orange": "Oranžová horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.pink": "Růžová horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.purple": "Fialová horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.red": "Červená horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.white": "Bílá horní pravá čtvrť",
  "block.minecraft.banner.square_top_left.yellow": "Žlutá horní pravá čtvrť",
  "block.minecraft.banner.square_top_right.black": "Černá horní levá čtvrť",
  "block.minecraft.banner.square_top_right.blue": "Modrá horní levá čtvrť",
  "block.minecraft.banner.square_top_right.brown": "Hnědá horní levá čtvrť",
  "block.minecraft.banner.square_top_right.cyan": "Azurová horní levá čtvrť",
  "block.minecraft.banner.square_top_right.gray": "Šedá horní levá čtvrť",
  "block.minecraft.banner.square_top_right.green": "Zelená horní levá čtvrť",
  "block.minecraft.banner.square_top_right.light_blue": "Světle modrá horní levá čtvrť",
  "block.minecraft.banner.square_top_right.light_gray": "Světle šedá horní levá čtvrť",
  "block.minecraft.banner.square_top_right.lime": "Světle zelená horní levá čtvrť",
  "block.minecraft.banner.square_top_right.magenta": "Purpurová horní levá čtvrť",
  "block.minecraft.banner.square_top_right.orange": "Oranžová horní levá čtvrť",
  "block.minecraft.banner.square_top_right.pink": "Růžová horní levá čtvrť",
  "block.minecraft.banner.square_top_right.purple": "Fialová horní levá čtvrť",
  "block.minecraft.banner.square_top_right.red": "Červená horní levá čtvrť",
  "block.minecraft.banner.square_top_right.white": "Bílá horní levá čtvrť",
  "block.minecraft.banner.square_top_right.yellow": "Žlutá horní levá čtvrť",
  "block.minecraft.banner.straight_cross.black": "Černý kříž",
  "block.minecraft.banner.straight_cross.blue": "Modrý kříž",
  "block.minecraft.banner.straight_cross.brown": "Hnědý kříž",
  "block.minecraft.banner.straight_cross.cyan": "Azurový kříž",
  "block.minecraft.banner.straight_cross.gray": "Šedý kříž",
  "block.minecraft.banner.straight_cross.green": "Zelený kříž",
  "block.minecraft.banner.straight_cross.light_blue": "Světle modrý kříž",
  "block.minecraft.banner.straight_cross.light_gray": "Světle šedý kříž",
  "block.minecraft.banner.straight_cross.lime": "Světle zelený kříž",
  "block.minecraft.banner.straight_cross.magenta": "Purpurový kříž",
  "block.minecraft.banner.straight_cross.orange": "Oranžový kříž",
  "block.minecraft.banner.straight_cross.pink": "Růžový kříž",
  "block.minecraft.banner.straight_cross.purple": "Fialový kříž",
  "block.minecraft.banner.straight_cross.red": "Červený kříž",
  "block.minecraft.banner.straight_cross.white": "Bílý kříž",
  "block.minecraft.banner.straight_cross.yellow": "Žlutý kříž",
  "block.minecraft.banner.stripe_bottom.black": "Černá pata",
  "block.minecraft.banner.stripe_bottom.blue": "Modrá pata",
  "block.minecraft.banner.stripe_bottom.brown": "Hnědá pata",
  "block.minecraft.banner.stripe_bottom.cyan": "Azurová pata",
  "block.minecraft.banner.stripe_bottom.gray": "Šedá pata",
  "block.minecraft.banner.stripe_bottom.green": "Zelená pata",
  "block.minecraft.banner.stripe_bottom.light_blue": "Světle modrá pata",
  "block.minecraft.banner.stripe_bottom.light_gray": "Světle šedá pata",
  "block.minecraft.banner.stripe_bottom.lime": "Světle zelená pata",
  "block.minecraft.banner.stripe_bottom.magenta": "Purpurová pata",
  "block.minecraft.banner.stripe_bottom.orange": "Oranžová pata",
  "block.minecraft.banner.stripe_bottom.pink": "Růžová pata",
  "block.minecraft.banner.stripe_bottom.purple": "Fialová pata",
  "block.minecraft.banner.stripe_bottom.red": "Červená pata",
  "block.minecraft.banner.stripe_bottom.white": "Bílá pata",
  "block.minecraft.banner.stripe_bottom.yellow": "Žlutá pata",
  "block.minecraft.banner.stripe_center.black": "Černý kůl",
  "block.minecraft.banner.stripe_center.blue": "Modrý kůl",
  "block.minecraft.banner.stripe_center.brown": "Hnědý kůl",
  "block.minecraft.banner.stripe_center.cyan": "Azurový kůl",
  "block.minecraft.banner.stripe_center.gray": "Šedý kůl",
  "block.minecraft.banner.stripe_center.green": "Zelený kůl",
  "block.minecraft.banner.stripe_center.light_blue": "Světle modrý kůl",
  "block.minecraft.banner.stripe_center.light_gray": "Světle šedý kůl",
  "block.minecraft.banner.stripe_center.lime": "Světle zelený kůl",
  "block.minecraft.banner.stripe_center.magenta": "Purpurový kůl",
  "block.minecraft.banner.stripe_center.orange": "Oranžový kůl",
  "block.minecraft.banner.stripe_center.pink": "Růžový kůl",
  "block.minecraft.banner.stripe_center.purple": "Fialový kůl",
  "block.minecraft.banner.stripe_center.red": "Červený kůl",
  "block.minecraft.banner.stripe_center.white": "Bílý kůl",
  "block.minecraft.banner.stripe_center.yellow": "Žlutý kůl",
  "block.minecraft.banner.stripe_downleft.black": "Černé šikmé břevno",
  "block.minecraft.banner.stripe_downleft.blue": "Modré šikmé břevno",
  "block.minecraft.banner.stripe_downleft.brown": "Hnědé šikmé břevno",
  "block.minecraft.banner.stripe_downleft.cyan": "Azurové šikmé břevno",
  "block.minecraft.banner.stripe_downleft.gray": "Šedé šikmé břevno",
  "block.minecraft.banner.stripe_downleft.green": "Zelené šikmé břevno",
  "block.minecraft.banner.stripe_downleft.light_blue": "Světle modré šikmé břevno",
  "block.minecraft.banner.stripe_downleft.light_gray": "Světle šedé šikmé břevno",
  "block.minecraft.banner.stripe_downleft.lime": "Světle zelené šikmé břevno",
  "block.minecraft.banner.stripe_downleft.magenta": "Purpurové šikmé břevno",
  "block.minecraft.banner.stripe_downleft.orange": "Oranžové šikmé břevno",
  "block.minecraft.banner.stripe_downleft.pink": "Růžové šikmé břevno",
  "block.minecraft.banner.stripe_downleft.purple": "Fialové šikmé břevno",
  "block.minecraft.banner.stripe_downleft.red": "Červené šikmé břevno",
  "block.minecraft.banner.stripe_downleft.white": "Bílé šikmé břevno",
  "block.minecraft.banner.stripe_downleft.yellow": "Žluté šikmé břevno",
  "block.minecraft.banner.stripe_downright.black": "Černé kosmé břevno",
  "block.minecraft.banner.stripe_downright.blue": "Modré kosmé břevno",
  "block.minecraft.banner.stripe_downright.brown": "Hnědé kosmé břevno",
  "block.minecraft.banner.stripe_downright.cyan": "Azurové kosmé břevno",
  "block.minecraft.banner.stripe_downright.gray": "Šedé kosmé břevno",
  "block.minecraft.banner.stripe_downright.green": "Zelené kosmé břevno",
  "block.minecraft.banner.stripe_downright.light_blue": "Světle modré kosmé břevno",
  "block.minecraft.banner.stripe_downright.light_gray": "Světle šedé kosmé břevno",
  "block.minecraft.banner.stripe_downright.lime": "Světle zelené kosmé břevno",
  "block.minecraft.banner.stripe_downright.magenta": "Purpurové kosmé břevno",
  "block.minecraft.banner.stripe_downright.orange": "Oranžové kosmé břevno",
  "block.minecraft.banner.stripe_downright.pink": "Růžové kosmé břevno",
  "block.minecraft.banner.stripe_downright.purple": "Fialové kosmé břevno",
  "block.minecraft.banner.stripe_downright.red": "Červené kosmé břevno",
  "block.minecraft.banner.stripe_downright.white": "Bílé kosmé břevno",
  "block.minecraft.banner.stripe_downright.yellow": "Žluté kosmé břevno",
  "block.minecraft.banner.stripe_left.black": "Černé pravé polcení",
  "block.minecraft.banner.stripe_left.blue": "Modré pravé polcení",
  "block.minecraft.banner.stripe_left.brown": "Hnědé pravé polcení",
  "block.minecraft.banner.stripe_left.cyan": "Azurové pravé polcení",
  "block.minecraft.banner.stripe_left.gray": "Šedé pravé polcení",
  "block.minecraft.banner.stripe_left.green": "Zelené pravé polcení",
  "block.minecraft.banner.stripe_left.light_blue": "Světle modré pravé polcení",
  "block.minecraft.banner.stripe_left.light_gray": "Světle šedé pravé polcení",
  "block.minecraft.banner.stripe_left.lime": "Světle zelené pravé polcení",
  "block.minecraft.banner.stripe_left.magenta": "Purpurové pravé polcení",
  "block.minecraft.banner.stripe_left.orange": "Oranžové pravé polcení",
  "block.minecraft.banner.stripe_left.pink": "Růžové pravé polcení",
  "block.minecraft.banner.stripe_left.purple": "Fialové pravé polcení",
  "block.minecraft.banner.stripe_left.red": "Červené pravé polcení",
  "block.minecraft.banner.stripe_left.white": "Bílé pravé polcení",
  "block.minecraft.banner.stripe_left.yellow": "Žluté pravé polcení",
  "block.minecraft.banner.stripe_middle.black": "Černé břevno",
  "block.minecraft.banner.stripe_middle.blue": "Modré břevno",
  "block.minecraft.banner.stripe_middle.brown": "Hnědé břevno",
  "block.minecraft.banner.stripe_middle.cyan": "Azurové břevno",
  "block.minecraft.banner.stripe_middle.gray": "Šedé břevno",
  "block.minecraft.banner.stripe_middle.green": "Zelené břevno",
  "block.minecraft.banner.stripe_middle.light_blue": "Světle modré břevno",
  "block.minecraft.banner.stripe_middle.light_gray": "Světle šedé břevno",
  "block.minecraft.banner.stripe_middle.lime": "Světle zelené břevno",
  "block.minecraft.banner.stripe_middle.magenta": "Purpurové břevno",
  "block.minecraft.banner.stripe_middle.orange": "Oranžové břevno",
  "block.minecraft.banner.stripe_middle.pink": "Růžové břevno",
  "block.minecraft.banner.stripe_middle.purple": "Fialové břevno",
  "block.minecraft.banner.stripe_middle.red": "Červené břevno",
  "block.minecraft.banner.stripe_middle.white": "Bílé břevno",
  "block.minecraft.banner.stripe_middle.yellow": "Žluté břevno",
  "block.minecraft.banner.stripe_right.black": "Černé levé polcení",
  "block.minecraft.banner.stripe_right.blue": "Modré levé polcení",
  "block.minecraft.banner.stripe_right.brown": "Hnědé levé polcení",
  "block.minecraft.banner.stripe_right.cyan": "Azurové levé polcení",
  "block.minecraft.banner.stripe_right.gray": "Šedé levé polcení",
  "block.minecraft.banner.stripe_right.green": "Zelené levé polcení",
  "block.minecraft.banner.stripe_right.light_blue": "Světle modré levé polcení",
  "block.minecraft.banner.stripe_right.light_gray": "Světle šedé levé polcení",
  "block.minecraft.banner.stripe_right.lime": "Světle zelené levé polcení",
  "block.minecraft.banner.stripe_right.magenta": "Purpurové levé polcení",
  "block.minecraft.banner.stripe_right.orange": "Oranžové levé polcení",
  "block.minecraft.banner.stripe_right.pink": "Růžové levé polcení",
  "block.minecraft.banner.stripe_right.purple": "Fialové levé polcení",
  "block.minecraft.banner.stripe_right.red": "Červené levé polcení",
  "block.minecraft.banner.stripe_right.white": "Bílé levé polcení",
  "block.minecraft.banner.stripe_right.yellow": "Žluté levé polcení",
  "block.minecraft.banner.stripe_top.black": "Černá hlava",
  "block.minecraft.banner.stripe_top.blue": "Modrá hlava",
  "block.minecraft.banner.stripe_top.brown": "Hnědá hlava",
  "block.minecraft.banner.stripe_top.cyan": "Azurová hlava",
  "block.minecraft.banner.stripe_top.gray": "Šedá hlava",
  "block.minecraft.banner.stripe_top.green": "Zelená hlava",
  "block.minecraft.banner.stripe_top.light_blue": "Světle modrá hlava",
  "block.minecraft.banner.stripe_top.light_gray": "Světle šedá hlava",
  "block.minecraft.banner.stripe_top.lime": "Světle zelená hlava",
  "block.minecraft.banner.stripe_top.magenta": "Purpurová hlava",
  "block.minecraft.banner.stripe_top.orange": "Oranžová hlava",
  "block.minecraft.banner.stripe_top.pink": "Růžová hlava",
  "block.minecraft.banner.stripe_top.purple": "Fialová hlava",
  "block.minecraft.banner.stripe_top.red": "Červená hlava",
  "block.minecraft.banner.stripe_top.white": "Bílá hlava",
  "block.minecraft.banner.stripe_top.yellow": "Žlutá hlava",
  "block.minecraft.banner.triangle_bottom.black": "Černý hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.blue": "Modrý hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.brown": "Hnědý hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.cyan": "Azurový hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.gray": "Šedý hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.green": "Zelený hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.light_blue": "Světle modrý hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.light_gray": "Světle šedý hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.lime": "Světle zelený hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.magenta": "Purpurový hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.orange": "Oranžový hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.pink": "Růžový hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.purple": "Fialový hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.red": "Červený hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.white": "Bílý hrot snížený do poloviny",
  "block.minecraft.banner.triangle_bottom.yellow": "Žlutý hrot snížený do poloviny",
  "block.minecraft.banner.triangle_top.black": "Černý klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.blue": "Modrý klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.brown": "Hnědý klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.cyan": "Azurový klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.gray": "Šedý klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.green": "Zelený klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.light_blue": "Světle modrý klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.light_gray": "Světle šedý klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.lime": "Světle zelený klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.magenta": "Purpurový klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.orange": "Oranžový klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.pink": "Růžový klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.purple": "Fialový klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.red": "Červený klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.white": "Bílý klín zvýšený do poloviny",
  "block.minecraft.banner.triangle_top.yellow": "Žlutý klín zvýšený do poloviny",
  "block.minecraft.banner.triangles_bottom.black": "Černý dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.blue": "Modrý dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.brown": "Hnědý dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.cyan": "Azurový dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.gray": "Šedý dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.green": "Zelený dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.light_blue": "Světle modrý dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.light_gray": "Světle šedý dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.lime": "Světle zelený dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.magenta": "Purpurový dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.orange": "Oranžový dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.pink": "Růžový dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.purple": "Fialový dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.red": "Červený dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.white": "Bílý dolní obloučkový lem",
  "block.minecraft.banner.triangles_bottom.yellow": "Žlutý dolní obloučkový lem",
  "block.minecraft.banner.triangles_top.black": "Černý horní obloučkový lem",
  "block.minecraft.banner.triangles_top.blue": "Modrý horní obloučkový lem",
  "block.minecraft.banner.triangles_top.brown": "Hnědý horní obloučkový lem",
  "block.minecraft.banner.triangles_top.cyan": "Azurový horní obloučkový lem",
  "block.minecraft.banner.triangles_top.gray": "Šedý horní obloučkový lem",
  "block.minecraft.banner.triangles_top.green": "Zelený horní obloučkový lem",
  "block.minecraft.banner.triangles_top.light_blue": "Světle modrý horní obloučkový lem",
  "block.minecraft.banner.triangles_top.light_gray": "Světle šedý horní obloučkový lem",
  "block.minecraft.banner.triangles_top.lime": "Světle zelený horní obloučkový lem",
  "block.minecraft.banner.triangles_top.magenta": "Purpurový horní obloučkový lem",
  "block.minecraft.banner.triangles_top.orange": "Oranžový horní obloučkový lem",
  "block.minecraft.banner.triangles_top.pink": "Růžový horní obloučkový lem",
  "block.minecraft.banner.triangles_top.purple": "Fialový horní obloučkový lem",
  "block.minecraft.banner.triangles_top.red": "Červený horní obloučkový lem",
  "block.minecraft.banner.triangles_top.white": "Bílý horní obloučkový lem",
  "block.minecraft.banner.triangles_top.yellow": "Žlutý horní obloučkový lem",
  "block.minecraft.barrel": "Sud",
  "block.minecraft.barrier": "Bariéra",
  "block.minecraft.basalt": "Čedič",
  "block.minecraft.beacon": "Maják",
  "block.minecraft.beacon.primary": "Hlavní schopnost",
  "block.minecraft.beacon.secondary": "Vedlejší schopnost",
  "block.minecraft.bed.no_sleep": "Můžeš spát pouze v noci nebo během bouřek",
  "block.minecraft.bed.not_safe": "Teď nemůžeš odpočívat, poblíž jsou obludy",
  "block.minecraft.bed.obstructed": "Tato postel je nepřístupná",
  "block.minecraft.bed.occupied": "Tato postel je obsazená",
  "block.minecraft.bed.too_far_away": "Teď nemůžeš odpočívat, postel je příliš daleko",
  "block.minecraft.bedrock": "Podloží",
  "block.minecraft.bee_nest": "Včelí hnízdo",
  "block.minecraft.beehive": "Včelí úl",
  "block.minecraft.beetroots": "Červená řepa",
  "block.minecraft.bell": "Zvon",
  "block.minecraft.big_dripleaf": "Velká krápenka",
  "block.minecraft.big_dripleaf_stem": "Stonek velké krápenky",
  "block.minecraft.birch_button": "Březové tlačítko",
  "block.minecraft.birch_door": "Březové dveře",
  "block.minecraft.birch_fence": "Březový plot",
  "block.minecraft.birch_fence_gate": "Březová branka",
  "block.minecraft.birch_hanging_sign": "Březová závěsná cedule",
  "block.minecraft.birch_leaves": "Březové listí",
  "block.minecraft.birch_log": "Březový kmen",
  "block.minecraft.birch_planks": "Březová prkna",
  "block.minecraft.birch_pressure_plate": "Březová nášlapná deska",
  "block.minecraft.birch_sapling": "Sazenice břízy",
  "block.minecraft.birch_shelf": "Březová polička",
  "block.minecraft.birch_sign": "Březová cedule",
  "block.minecraft.birch_slab": "Březový půlblok",
  "block.minecraft.birch_stairs": "Březové schody",
  "block.minecraft.birch_trapdoor": "Březový poklop",
  "block.minecraft.birch_wall_hanging_sign": "Březová závěsná cedule na zdi",
  "block.minecraft.birch_wall_sign": "Březová cedule na zdi",
  "block.minecraft.birch_wood": "Březové dřevo",
  "block.minecraft.black_banner": "Černý prapor",
  "block.minecraft.black_bed": "Černá postel",
  "block.minecraft.black_candle": "Černá svíčka",
  "block.minecraft.black_candle_cake": "Dort s černou svíčkou",
  "block.minecraft.black_carpet": "Černý koberec",
  "block.minecraft.black_concrete": "Černý beton",
  "block.minecraft.black_concrete_powder": "Černý cement",
  "block.minecraft.black_glazed_terracotta": "Černá glazovaná terakota",
  "block.minecraft.black_shulker_box": "Černá shulkerova schránka",
  "block.minecraft.black_stained_glass": "Černé sklo",
  "block.minecraft.black_stained_glass_pane": "Tabulka černého skla",
  "block.minecraft.black_terracotta": "Černá terakota",
  "block.minecraft.black_wool": "Černá vlna",
  "block.minecraft.blackstone": "Černokámen",
  "block.minecraft.blackstone_slab": "Černokamenný půlblok",
  "block.minecraft.blackstone_stairs": "Černokamenné schody",
  "block.minecraft.blackstone_wall": "Černokamenná zídka",
  "block.minecraft.blast_furnace": "Tavicí pec",
  "block.minecraft.blue_banner": "Modrý prapor",
  "block.minecraft.blue_bed": "Modrá postel",
  "block.minecraft.blue_candle": "Modrá svíčka",
  "block.minecraft.blue_candle_cake": "Dort s modrou svíčkou",
  "block.minecraft.blue_carpet": "Modrý koberec",
  "block.minecraft.blue_concrete": "Modrý beton",
  "block.minecraft.blue_concrete_powder": "Modrý cement",
  "block.minecraft.blue_glazed_terracotta": "Modrá glazovaná terakota",
  "block.minecraft.blue_ice": "Modrý led",
  "block.minecraft.blue_orchid": "Modrá orchidej",
  "block.minecraft.blue_shulker_box": "Modrá shulkerova schránka",
  "block.minecraft.blue_stained_glass": "Modré sklo",
  "block.minecraft.blue_stained_glass_pane": "Tabulka modrého skla",
  "block.minecraft.blue_terracotta": "Modrá terakota",
  "block.minecraft.blue_wool": "Modrá vlna",
  "block.minecraft.bone_block": "Kostní blok",
  "block.minecraft.bookshelf": "Knihovna",
  "block.minecraft.brain_coral": "Mozkový korál",
  "block.minecraft.brain_coral_block": "Blok mozkového korálu",
  "block.minecraft.brain_coral_fan": "Vějíř mozkového korálu",
  "block.minecraft.brain_coral_wall_fan": "Vějíř mozkového korálu na zdi",
  "block.minecraft.brewing_stand": "Varný stojan",
  "block.minecraft.brick_slab": "Cihlový půlblok",
  "block.minecraft.brick_stairs": "Cihlové schody",
  "block.minecraft.brick_wall": "Cihlová zídka",
  "block.minecraft.bricks": "Cihly",
  "block.minecraft.brown_banner": "Hnědý prapor",
  "block.minecraft.brown_bed": "Hnědá postel",
  "block.minecraft.brown_candle": "Hnědá svíčka",
  "block.minecraft.brown_candle_cake": "Dort s hnědou svíčkou",
  "block.minecraft.brown_carpet": "Hnědý koberec",
  "block.minecraft.brown_concrete": "Hnědý beton",
  "block.minecraft.brown_concrete_powder": "Hnědý cement",
  "block.minecraft.brown_glazed_terracotta": "Hnědá glazovaná terakota",
  "block.minecraft.brown_mushroom": "Hřib",
  "block.minecraft.brown_mushroom_block": "Hřibový blok",
  "block.minecraft.brown_shulker_box": "Hnědá shulkerova schránka",
  "block.minecraft.brown_stained_glass": "Hnědé sklo",
  "block.minecraft.brown_stained_glass_pane": "Tabulka hnědého skla",
  "block.minecraft.brown_terracotta": "Hnědá terakota",
  "block.minecraft.brown_wool": "Hnědá vlna",
  "block.minecraft.bubble_column": "Bubliny",
  "block.minecraft.bubble_coral": "Bublinový korál",
  "block.minecraft.bubble_coral_block": "Blok bublinového korálu",
  "block.minecraft.bubble_coral_fan": "Vějíř bublinového korálu",
  "block.minecraft.bubble_coral_wall_fan": "Vějíř bublinového korálu na zdi",
  "block.minecraft.budding_amethyst": "Krystalizující ametyst",
  "block.minecraft.bush": "Keř",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusový květ",
  "block.minecraft.cake": "Dort",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrované sculkové čidlo",
  "block.minecraft.campfire": "Táborák",
  "block.minecraft.candle": "Svíčka",
  "block.minecraft.candle_cake": "Dort se svíčkou",
  "block.minecraft.carrots": "Mrkve",
  "block.minecraft.cartography_table": "Kartografický stůl",
  "block.minecraft.carved_pumpkin": "Vydlabaná dýně",
  "block.minecraft.cauldron": "Kotel",
  "block.minecraft.cave_air": "Vzduch",
  "block.minecraft.cave_vines": "Jeskynní liána",
  "block.minecraft.cave_vines_plant": "Stonek jeskyní liány",
  "block.minecraft.chain": "Řetěz",
  "block.minecraft.chain_command_block": "Řetězový příkazový blok",
  "block.minecraft.cherry_button": "Třešňové tlačítko",
  "block.minecraft.cherry_door": "Třešňové dveře",
  "block.minecraft.cherry_fence": "Třešňový plot",
  "block.minecraft.cherry_fence_gate": "Třešňová branka",
  "block.minecraft.cherry_hanging_sign": "Třešňová závěsná cedule",
  "block.minecraft.cherry_leaves": "Třešňové listí",
  "block.minecraft.cherry_log": "Třešňový kmen",
  "block.minecraft.cherry_planks": "Třešňová prkna",
  "block.minecraft.cherry_pressure_plate": "Třešňová nášlapná deska",
  "block.minecraft.cherry_sapling": "Sazenice třešně",
  "block.minecraft.cherry_shelf": "Třešňová polička",
  "block.minecraft.cherry_sign": "Třešňová cedule",
  "block.minecraft.cherry_slab": "Třešňový půlblok",
  "block.minecraft.cherry_stairs": "Třešňové schody",
  "block.minecraft.cherry_trapdoor": "Třešňový poklop",
  "block.minecraft.cherry_wall_hanging_sign": "Třešňová závěsná cedule",
  "block.minecraft.cherry_wall_sign": "Třešňová cedule na zdi",
  "block.minecraft.cherry_wood": "Třešňové dřevo",
  "block.minecraft.chest": "Truhla",
  "block.minecraft.chipped_anvil": "Opotřebená kovadlina",
  "block.minecraft.chiseled_bookshelf": "Vyřezávaná knihovna",
  "block.minecraft.chiseled_copper": "Opracovaná měď",
  "block.minecraft.chiseled_deepslate": "Opracovaná břidlice",
  "block.minecraft.chiseled_nether_bricks": "Opracované netherové cihly",
  "block.minecraft.chiseled_polished_blackstone": "Opracovaný leštěný černokámen",
  "block.minecraft.chiseled_quartz_block": "Opracovaný blok křemene",
  "block.minecraft.chiseled_red_sandstone": "Opracovaný rudý pískovec",
  "block.minecraft.chiseled_resin_bricks": "Opracované cihly z pryskyřice",
  "block.minecraft.chiseled_sandstone": "Opracovaný pískovec",
  "block.minecraft.chiseled_stone_bricks": "Opracované kamenné cihly",
  "block.minecraft.chiseled_tuff": "Opracovaný tuf",
  "block.minecraft.chiseled_tuff_bricks": "Cihly z opracovaného tufu",
  "block.minecraft.chorus_flower": "Květ chorusu",
  "block.minecraft.chorus_plant": "Chorus",
  "block.minecraft.clay": "Blok jílu",
  "block.minecraft.closed_eyeblossom": "Uzavřená očenka",
  "block.minecraft.coal_block": "Uhelný blok",
  "block.minecraft.coal_ore": "Ložisko uhlí",
  "block.minecraft.coarse_dirt": "Hrubá hlína",
  "block.minecraft.cobbled_deepslate": "Břidlicové kamenivo",
  "block.minecraft.cobbled_deepslate_slab": "Půlblok z břidlicového kameniva",
  "block.minecraft.cobbled_deepslate_stairs": "Schody z břidlicového kameniva",
  "block.minecraft.cobbled_deepslate_wall": "Zídka z břidlicového kameniva",
  "block.minecraft.cobblestone": "Kamení",
  "block.minecraft.cobblestone_slab": "Půlblok z kamení",
  "block.minecraft.cobblestone_stairs": "Schody z kamení",
  "block.minecraft.cobblestone_wall": "Zídka z kamení",
  "block.minecraft.cobweb": "Pavučina",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Příkazový blok",
  "block.minecraft.comparator": "Redstonový porovnávač",
  "block.minecraft.composter": "Kompostér",
  "block.minecraft.conduit": "Zářič",
  "block.minecraft.copper_bars": "Měděné mříže",
  "block.minecraft.copper_block": "Blok mědi",
  "block.minecraft.copper_bulb": "Měděná lampa",
  "block.minecraft.copper_chain": "Měděný řetěz",
  "block.minecraft.copper_chest": "Měděná truhla",
  "block.minecraft.copper_door": "Měděné dveře",
  "block.minecraft.copper_golem_statue": "Soška měděného golema",
  "block.minecraft.copper_grate": "Měděný rošt",
  "block.minecraft.copper_lantern": "Měděná lucerna",
  "block.minecraft.copper_ore": "Měděná ruda",
  "block.minecraft.copper_torch": "Měděná louč",
  "block.minecraft.copper_trapdoor": "Měděný poklop",
  "block.minecraft.copper_wall_torch": "Měděná louč na zdi",
  "block.minecraft.cornflower": "Chrpa",
  "block.minecraft.cracked_deepslate_bricks": "Popraskané břidlicové cihly",
  "block.minecraft.cracked_deepslate_tiles": "Popraskaná břidlicová dlažba",
  "block.minecraft.cracked_nether_bricks": "Popraskané netherové cihly",
  "block.minecraft.cracked_polished_blackstone_bricks": "Popraskané cihly z leštěného černokamene",
  "block.minecraft.cracked_stone_bricks": "Popraskané kamenné cihly",
  "block.minecraft.crafter": "Výrobník",
  "block.minecraft.crafting_table": "Pracovní stůl",
  "block.minecraft.creaking_heart": "Skřípotovo srdce",
  "block.minecraft.creeper_head": "Hlava creepera",
  "block.minecraft.creeper_wall_head": "Hlava creepera na zdi",
  "block.minecraft.crimson_button": "Karmínové tlačítko",
  "block.minecraft.crimson_door": "Karmínové dveře",
  "block.minecraft.crimson_fence": "Karmínový plot",
  "block.minecraft.crimson_fence_gate": "Karmínová branka",
  "block.minecraft.crimson_fungus": "Karmínová houba",
  "block.minecraft.crimson_hanging_sign": "Karmínová závěsná cedule",
  "block.minecraft.crimson_hyphae": "Karmínová stélka",
  "block.minecraft.crimson_nylium": "Karmínové podhoubí",
  "block.minecraft.crimson_planks": "Karmínová prkna",
  "block.minecraft.crimson_pressure_plate": "Karmínová nášlapná deska",
  "block.minecraft.crimson_roots": "Karmínové kořínky",
  "block.minecraft.crimson_shelf": "Karmínová polička",
  "block.minecraft.crimson_sign": "Karmínová cedule",
  "block.minecraft.crimson_slab": "Karmínový půlblok",
  "block.minecraft.crimson_stairs": "Karmínové schody",
  "block.minecraft.crimson_stem": "Karmínová třeň",
  "block.minecraft.crimson_trapdoor": "Karmínový poklop",
  "block.minecraft.crimson_wall_hanging_sign": "Karmínová závěsná cedule na zdi",
  "block.minecraft.crimson_wall_sign": "Karmínová cedule na zdi",
  "block.minecraft.crying_obsidian": "Plačící obsidián",
  "block.minecraft.cut_copper": "Tepaná měď",
  "block.minecraft.cut_copper_slab": "Půlblok z tepané mědi",
  "block.minecraft.cut_copper_stairs": "Schody z tepané mědi",
  "block.minecraft.cut_red_sandstone": "Řezaný rudý pískovec",
  "block.minecraft.cut_red_sandstone_slab": "Půlblok řezaného rudého pískovce",
  "block.minecraft.cut_sandstone": "Řezaný pískovec",
  "block.minecraft.cut_sandstone_slab": "Půlblok řezaného pískovce",
  "block.minecraft.cyan_banner": "Azurový prapor",
  "block.minecraft.cyan_bed": "Azurová postel",
  "block.minecraft.cyan_candle": "Azurová svíčka",
  "block.minecraft.cyan_candle_cake": "Dort s azurovou svíčkou",
  "block.minecraft.cyan_carpet": "Azurový koberec",
  "block.minecraft.cyan_concrete": "Azurový beton",
  "block.minecraft.cyan_concrete_powder": "Azurový cement",
  "block.minecraft.cyan_glazed_terracotta": "Azurová glazovaná terakota",
  "block.minecraft.cyan_shulker_box": "Azurová shulkerova schránka",
  "block.minecraft.cyan_stained_glass": "Azurové sklo",
  "block.minecraft.cyan_stained_glass_pane": "Tabulka azurového skla",
  "block.minecraft.cyan_terracotta": "Azurová terakota",
  "block.minecraft.cyan_wool": "Azurová vlna",
  "block.minecraft.damaged_anvil": "Poškozená kovadlina",
  "block.minecraft.dandelion": "Pampeliška",
  "block.minecraft.dark_oak_button": "Tlačítko z tmavého dubu",
  "block.minecraft.dark_oak_door": "Dveře z tmavého dubu",
  "block.minecraft.dark_oak_fence": "Plot z tmavého dubu",
  "block.minecraft.dark_oak_fence_gate": "Branka z tmavého dubu",
  "block.minecraft.dark_oak_hanging_sign": "Závěsná cedule z tmavého dubu",
  "block.minecraft.dark_oak_leaves": "Listí tmavého dubu",
  "block.minecraft.dark_oak_log": "Kmen z tmavého dubu",
  "block.minecraft.dark_oak_planks": "Prkna z tmavého dubu",
  "block.minecraft.dark_oak_pressure_plate": "Nášlapná deska z tmavého dubu",
  "block.minecraft.dark_oak_sapling": "Sazenice tmavého dubu",
  "block.minecraft.dark_oak_shelf": "Polička z tmavého dubu",
  "block.minecraft.dark_oak_sign": "Cedule z tmavého dubu",
  "block.minecraft.dark_oak_slab": "Půlblok z tmavého dubu",
  "block.minecraft.dark_oak_stairs": "Schody z tmavého dubu",
  "block.minecraft.dark_oak_trapdoor": "Poklop z tmavého dubu",
  "block.minecraft.dark_oak_wall_hanging_sign": "Závěsná cedule z tmavého dubu na zdi",
  "block.minecraft.dark_oak_wall_sign": "Cedule z tmavého dubu na zdi",
  "block.minecraft.dark_oak_wood": "Dřevo z tmavého dubu",
  "block.minecraft.dark_prismarine": "Tmavý prismarín",
  "block.minecraft.dark_prismarine_slab": "Půlblok z tmavého prismarínu",
  "block.minecraft.dark_prismarine_stairs": "Schody z tmavého prismarínu",
  "block.minecraft.daylight_detector": "Senzor denního světla",
  "block.minecraft.dead_brain_coral": "Mrtvý mozkový korál",
  "block.minecraft.dead_brain_coral_block": "Blok mrtvého mozkového korálu",
  "block.minecraft.dead_brain_coral_fan": "Blok mrtvého mozkového korálu",
  "block.minecraft.dead_brain_coral_wall_fan": "Mrtvý vějíř mozkového korálu na zdi",
  "block.minecraft.dead_bubble_coral": "Mrtvý bublinový korál",
  "block.minecraft.dead_bubble_coral_block": "Blok mrtvého bublinového korálu",
  "block.minecraft.dead_bubble_coral_fan": "Blok mrtvého bublinového korálu",
  "block.minecraft.dead_bubble_coral_wall_fan": "Mrtvý vějíř bublinového korálu na zdi",
  "block.minecraft.dead_bush": "Suchý keř",
  "block.minecraft.dead_fire_coral": "Mrtvý žahavkový korál",
  "block.minecraft.dead_fire_coral_block": "Blok mrtvého žahavkového korálu",
  "block.minecraft.dead_fire_coral_fan": "Blok mrtvého žahavkového korálu",
  "block.minecraft.dead_fire_coral_wall_fan": "Mrtvý vějíř žahavkového korálu na zdi",
  "block.minecraft.dead_horn_coral": "Mrtvý drsnatý korál",
  "block.minecraft.dead_horn_coral_block": "Blok mrtvého drsnatého korálu",
  "block.minecraft.dead_horn_coral_fan": "Blok mrtvého drsnatého korálu",
  "block.minecraft.dead_horn_coral_wall_fan": "Mrtvý vějíř drsnatého korálu na zdi",
  "block.minecraft.dead_tube_coral": "Mrtvý varhanitkový korál",
  "block.minecraft.dead_tube_coral_block": "Blok mrtvého varhanitkového korálu",
  "block.minecraft.dead_tube_coral_fan": "Blok mrtvého varhanitkového korálu",
  "block.minecraft.dead_tube_coral_wall_fan": "Mrtvý vějíř varhanitkového korálu na zdi",
  "block.minecraft.decorated_pot": "Zdobený hrnec",
  "block.minecraft.deepslate": "Břidlice",
  "block.minecraft.deepslate_brick_slab": "Půlblok z břidlicových cihel",
  "block.minecraft.deepslate_brick_stairs": "Schody z břidlicových cihel",
  "block.minecraft.deepslate_brick_wall": "Zídka z břidlicových cihel",
  "block.minecraft.deepslate_bricks": "Břidlicové cihly",
  "block.minecraft.deepslate_coal_ore": "Hlubinné ložisko uhlí",
  "block.minecraft.deepslate_copper_ore": "Hlubinná měděná ruda",
  "block.minecraft.deepslate_diamond_ore": "Hlubinné diamantové ložisko",
  "block.minecraft.deepslate_emerald_ore": "Hlubinné smaragdové ložisko",
  "block.minecraft.deepslate_gold_ore": "Hlubinná zlatá ruda",
  "block.minecraft.deepslate_iron_ore": "Hlubinná železná ruda",
  "block.minecraft.deepslate_lapis_ore": "Hlubinné ložisko lazuritu",
  "block.minecraft.deepslate_redstone_ore": "Hlubinné redstonové ložisko",
  "block.minecraft.deepslate_tile_slab": "Půlblok z břidlicové dlažby",
  "block.minecraft.deepslate_tile_stairs": "Schody z břidlicové dlažby",
  "block.minecraft.deepslate_tile_wall": "Zídka z břidlicové dlažby",
  "block.minecraft.deepslate_tiles": "Břidlicová dlažba",
  "block.minecraft.detector_rail": "Senzorová kolej",
  "block.minecraft.diamond_block": "Diamantový blok",
  "block.minecraft.diamond_ore": "Diamantové ložisko",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritový půlblok",
  "block.minecraft.diorite_stairs": "Dioritové schody",
  "block.minecraft.diorite_wall": "Dioritová zídka",
  "block.minecraft.dirt": "Hlína",
  "block.minecraft.dirt_path": "Pěšina",
  "block.minecraft.dispenser": "Dávkovač",
  "block.minecraft.dragon_egg": "Dračí vejce",
  "block.minecraft.dragon_head": "Hlava draka",
  "block.minecraft.dragon_wall_head": "Hlava draka na zdi",
  "block.minecraft.dried_ghast": "Vysušený ghast",
  "block.minecraft.dried_kelp_block": "Balík sušených chaluh",
  "block.minecraft.dripstone_block": "Blok krápníku",
  "block.minecraft.dropper": "Podavač",
  "block.minecraft.emerald_block": "Smaragdový blok",
  "block.minecraft.emerald_ore": "Smaragdové ložisko",
  "block.minecraft.enchanting_table": "Oltář očarování",
  "block.minecraft.end_gateway": "Brána Endu",
  "block.minecraft.end_portal": "Portál do Endu",
  "block.minecraft.end_portal_frame": "Rám portálu do Endu",
  "block.minecraft.end_rod": "Enderitová tyč",
  "block.minecraft.end_stone": "Enderit",
  "block.minecraft.end_stone_brick_slab": "Půlblok z enderitových cihel",
  "block.minecraft.end_stone_brick_stairs": "Schody z enderitových cihel",
  "block.minecraft.end_stone_brick_wall": "Zídka z enderitových cihel",
  "block.minecraft.end_stone_bricks": "Enderitové cihly",
  "block.minecraft.ender_chest": "Enderitová truhla",
  "block.minecraft.exposed_chiseled_copper": "Opracovaná měď s lehkou měděnkou",
  "block.minecraft.exposed_copper": "Měď s lehkou měděnkou",
  "block.minecraft.exposed_copper_bars": "Měděné mříže s lehkou měděnkou",
  "block.minecraft.exposed_copper_bulb": "Měděná lampa s lehkou měděnkou",
  "block.minecraft.exposed_copper_chain": "Měděný řetěz s lehkou měděnkou",
  "block.minecraft.exposed_copper_chest": "Měděná truhla s lehkou měděnkou",
  "block.minecraft.exposed_copper_door": "Měděné dveře s lehkou měděnkou",
  "block.minecraft.exposed_copper_golem_statue": "Soška měděného golema s lehkou měděnkou",
  "block.minecraft.exposed_copper_grate": "Měděný rošt s lehkou měděnkou",
  "block.minecraft.exposed_copper_lantern": "Měděná lucerna s lehkou měděnkou",
  "block.minecraft.exposed_copper_trapdoor": "Měděný poklop s lehkou měděnkou",
  "block.minecraft.exposed_cut_copper": "Tepaná měď s lehkou měděnkou",
  "block.minecraft.exposed_cut_copper_slab": "Tepaný půlblok s lehkou měděnkou",
  "block.minecraft.exposed_cut_copper_stairs": "Tepané schody s lehkou měděnkou",
  "block.minecraft.exposed_lightning_rod": "Hromosvod s lehkou měděnkou",
  "block.minecraft.farmland": "Ornice",
  "block.minecraft.fern": "Kapradina",
  "block.minecraft.fire": "Oheň",
  "block.minecraft.fire_coral": "Žahavkový korál",
  "block.minecraft.fire_coral_block": "Blok žahavkového korálu",
  "block.minecraft.fire_coral_fan": "Vějíř žahavkového korálu",
  "block.minecraft.fire_coral_wall_fan": "Vějíř žahavkového korálu na zdi",
  "block.minecraft.firefly_bush": "Keř se světluškami",
  "block.minecraft.fletching_table": "Stůl na výrobu šípů",
  "block.minecraft.flower_pot": "Květináč",
  "block.minecraft.flowering_azalea": "Kvetoucí azalka",
  "block.minecraft.flowering_azalea_leaves": "Azalkové listí s květy",
  "block.minecraft.frogspawn": "Žabí vajíčka",
  "block.minecraft.frosted_ice": "Křehký led",
  "block.minecraft.furnace": "Pec",
  "block.minecraft.gilded_blackstone": "Zlatonosný černokámen",
  "block.minecraft.glass": "Sklo",
  "block.minecraft.glass_pane": "Tabulka skla",
  "block.minecraft.glow_lichen": "Světélkující lišejník",
  "block.minecraft.glowstone": "Světlit",
  "block.minecraft.gold_block": "Blok zlata",
  "block.minecraft.gold_ore": "Zlatá ruda",
  "block.minecraft.golden_dandelion": "Zlatá pampeliška",
  "block.minecraft.granite": "Žula",
  "block.minecraft.granite_slab": "Žulový půlblok",
  "block.minecraft.granite_stairs": "Žulové schody",
  "block.minecraft.granite_wall": "Žulová zídka",
  "block.minecraft.grass": "Tráva",
  "block.minecraft.grass_block": "Trávník",
  "block.minecraft.gravel": "Štěrk",
  "block.minecraft.gray_banner": "Šedý prapor",
  "block.minecraft.gray_bed": "Šedá postel",
  "block.minecraft.gray_candle": "Šedá svíčka",
  "block.minecraft.gray_candle_cake": "Dort se šedou svíčkou",
  "block.minecraft.gray_carpet": "Šedý koberec",
  "block.minecraft.gray_concrete": "Šedý beton",
  "block.minecraft.gray_concrete_powder": "Šedý cement",
  "block.minecraft.gray_glazed_terracotta": "Šedá glazovaná terakota",
  "block.minecraft.gray_shulker_box": "Šedá shulkerova schránka",
  "block.minecraft.gray_stained_glass": "Šedé sklo",
  "block.minecraft.gray_stained_glass_pane": "Tabulka šedého skla",
  "block.minecraft.gray_terracotta": "Šedá terakota",
  "block.minecraft.gray_wool": "Šedá vlna",
  "block.minecraft.green_banner": "Zelený prapor",
  "block.minecraft.green_bed": "Zelená postel",
  "block.minecraft.green_candle": "Zelená svíčka",
  "block.minecraft.green_candle_cake": "Dort se zelenou svíčkou",
  "block.minecraft.green_carpet": "Zelený koberec",
  "block.minecraft.green_concrete": "Zelený beton",
  "block.minecraft.green_concrete_powder": "Zelený cement",
  "block.minecraft.green_glazed_terracotta": "Zelená glazovaná terakota",
  "block.minecraft.green_shulker_box": "Zelená shulkerova schránka",
  "block.minecraft.green_stained_glass": "Zelené sklo",
  "block.minecraft.green_stained_glass_pane": "Tabulka zeleného skla",
  "block.minecraft.green_terracotta": "Zelená terakota",
  "block.minecraft.green_wool": "Zelená vlna",
  "block.minecraft.grindstone": "Brusný kámen",
  "block.minecraft.hanging_roots": "Visící kořeny",
  "block.minecraft.hay_block": "Balík slámy",
  "block.minecraft.heavy_core": "Těžké jádro",
  "block.minecraft.heavy_weighted_pressure_plate": "Zátěžová vážní nášlapná deska",
  "block.minecraft.honey_block": "Blok medu",
  "block.minecraft.honeycomb_block": "Blok medových pláství",
  "block.minecraft.hopper": "Násypka",
  "block.minecraft.horn_coral": "Drsnatý korál",
  "block.minecraft.horn_coral_block": "Blok drsnatého korálu",
  "block.minecraft.horn_coral_fan": "Vějíř drsnatého korálu",
  "block.minecraft.horn_coral_wall_fan": "Vějíř drsnatého korálu na zdi",
  "block.minecraft.ice": "Led",
  "block.minecraft.infested_chiseled_stone_bricks": "Zamořené opracované kamenné cihly",
  "block.minecraft.infested_cobblestone": "Zamořené kamení",
  "block.minecraft.infested_cracked_stone_bricks": "Zamořené popraskané kamenné cihly",
  "block.minecraft.infested_deepslate": "Zamořená břidlice",
  "block.minecraft.infested_mossy_stone_bricks": "Zamořené omšelé kamenné cihly",
  "block.minecraft.infested_stone": "Zamořený kámen",
  "block.minecraft.infested_stone_bricks": "Zamořené kamenné cihly",
  "block.minecraft.iron_bars": "Železné mříže",
  "block.minecraft.iron_block": "Blok železa",
  "block.minecraft.iron_chain": "Železný řetěz",
  "block.minecraft.iron_door": "Železné dveře",
  "block.minecraft.iron_ore": "Železná ruda",
  "block.minecraft.iron_trapdoor": "Železný poklop",
  "block.minecraft.jack_o_lantern": "Svítící dýně",
  "block.minecraft.jigsaw": "Blok skládačky",
  "block.minecraft.jukebox": "Hrací skříň",
  "block.minecraft.jungle_button": "Tlačítko z tropického dřeva",
  "block.minecraft.jungle_door": "Dveře z tropického dřeva",
  "block.minecraft.jungle_fence": "Plot z tropického dřeva",
  "block.minecraft.jungle_fence_gate": "Branka z tropického dřeva",
  "block.minecraft.jungle_hanging_sign": "Závěsná cedule z tropického dřeva",
  "block.minecraft.jungle_leaves": "Tropické listí",
  "block.minecraft.jungle_log": "Kmen z tropického stromu",
  "block.minecraft.jungle_planks": "Prkna z tropického dřeva",
  "block.minecraft.jungle_pressure_plate": "Nášlapná deska z tropického dřeva",
  "block.minecraft.jungle_sapling": "Sazenice tropického stromu",
  "block.minecraft.jungle_shelf": "Polička z tropického dřeva",
  "block.minecraft.jungle_sign": "Cedule z tropického dřeva",
  "block.minecraft.jungle_slab": "Půlblok z tropického dřeva",
  "block.minecraft.jungle_stairs": "Schody z tropického dřeva",
  "block.minecraft.jungle_trapdoor": "Poklop z tropického dřeva",
  "block.minecraft.jungle_wall_hanging_sign": "Závěsná cedule z tropického dřeva na zdi",
  "block.minecraft.jungle_wall_sign": "Cedule z tropického dřeva na zdi",
  "block.minecraft.jungle_wood": "Tropické dřevo",
  "block.minecraft.kelp": "Chaluha",
  "block.minecraft.kelp_plant": "Rostoucí chaluha",
  "block.minecraft.ladder": "Žebřík",
  "block.minecraft.lantern": "Lucerna",
  "block.minecraft.lapis_block": "Blok lazuritu",
  "block.minecraft.lapis_ore": "Ložisko lazuritu",
  "block.minecraft.large_amethyst_bud": "Velký trs ametystů",
  "block.minecraft.large_fern": "Velká kapradina",
  "block.minecraft.lava": "Láva",
  "block.minecraft.lava_cauldron": "Kotel s lávou",
  "block.minecraft.leaf_litter": "Spadané listí",
  "block.minecraft.lectern": "Čtecí pult",
  "block.minecraft.lever": "Páka",
  "block.minecraft.light": "Světlo",
  "block.minecraft.light_blue_banner": "Světle modrý prapor",
  "block.minecraft.light_blue_bed": "Světle modrá postel",
  "block.minecraft.light_blue_candle": "Světle modrá svíčka",
  "block.minecraft.light_blue_candle_cake": "Dort se světle modrou svíčkou",
  "block.minecraft.light_blue_carpet": "Světle modrý koberec",
  "block.minecraft.light_blue_concrete": "Světle modrý beton",
  "block.minecraft.light_blue_concrete_powder": "Světle modrý cement",
  "block.minecraft.light_blue_glazed_terracotta": "Světle modrá glazovaná terakota",
  "block.minecraft.light_blue_shulker_box": "Světle modrá shulkerova schránka",
  "block.minecraft.light_blue_stained_glass": "Světle modré sklo",
  "block.minecraft.light_blue_stained_glass_pane": "Tabulka světle modrého skla",
  "block.minecraft.light_blue_terracotta": "Světle modrá terakota",
  "block.minecraft.light_blue_wool": "Světle modrá vlna",
  "block.minecraft.light_gray_banner": "Světle šedý prapor",
  "block.minecraft.light_gray_bed": "Světle šedá postel",
  "block.minecraft.light_gray_candle": "Světle šedá svíčka",
  "block.minecraft.light_gray_candle_cake": "Dort se světle šedou svíčkou",
  "block.minecraft.light_gray_carpet": "Světle šedý koberec",
  "block.minecraft.light_gray_concrete": "Světle šedý beton",
  "block.minecraft.light_gray_concrete_powder": "Světle šedý cement",
  "block.minecraft.light_gray_glazed_terracotta": "Světle šedá glazovaná terakota",
  "block.minecraft.light_gray_shulker_box": "Světle šedá shulkerova schránka",
  "block.minecraft.light_gray_stained_glass": "Světle šedé sklo",
  "block.minecraft.light_gray_stained_glass_pane": "Tabulka světle šedého skla",
  "block.minecraft.light_gray_terracotta": "Světle šedá terakota",
  "block.minecraft.light_gray_wool": "Světle šedá vlna",
  "block.minecraft.light_weighted_pressure_plate": "Citlivá vážní nášlapná deska",
  "block.minecraft.lightning_rod": "Hromosvod",
  "block.minecraft.lilac": "Šeřík",
  "block.minecraft.lily_of_the_valley": "Konvalinka",
  "block.minecraft.lily_pad": "Leknín",
  "block.minecraft.lime_banner": "Světle zelený prapor",
  "block.minecraft.lime_bed": "Světle zelená postel",
  "block.minecraft.lime_candle": "Světle zelená svíčka",
  "block.minecraft.lime_candle_cake": "Dort se světle zelenou svíčkou",
  "block.minecraft.lime_carpet": "Světle zelený koberec",
  "block.minecraft.lime_concrete": "Světle zelený beton",
  "block.minecraft.lime_concrete_powder": "Světle zelený cement",
  "block.minecraft.lime_glazed_terracotta": "Světle zelená glazovaná terakota",
  "block.minecraft.lime_shulker_box": "Světle zelená shulkerova schránka",
  "block.minecraft.lime_stained_glass": "Světle zelené sklo",
  "block.minecraft.lime_stained_glass_pane": "Tabulka světle zeleného skla",
  "block.minecraft.lime_terracotta": "Světle zelená terakota",
  "block.minecraft.lime_wool": "Světle zelená vlna",
  "block.minecraft.lodestone": "Navigační kámen",
  "block.minecraft.loom": "Tkalcovský stav",
  "block.minecraft.magenta_banner": "Purpurový prapor",
  "block.minecraft.magenta_bed": "Purpurová postel",
  "block.minecraft.magenta_candle": "Purpurová svíčka",
  "block.minecraft.magenta_candle_cake": "Dort s purpurovou svíčkou",
  "block.minecraft.magenta_carpet": "Purpurový koberec",
  "block.minecraft.magenta_concrete": "Purpurový beton",
  "block.minecraft.magenta_concrete_powder": "Purpurový cement",
  "block.minecraft.magenta_glazed_terracotta": "Purpurová glazovaná terakota",
  "block.minecraft.magenta_shulker_box": "Purpurová shulkerova schránka",
  "block.minecraft.magenta_stained_glass": "Purpurové sklo",
  "block.minecraft.magenta_stained_glass_pane": "Tabulka purpurového skla",
  "block.minecraft.magenta_terracotta": "Purpurová terakota",
  "block.minecraft.magenta_wool": "Purpurová vlna",
  "block.minecraft.magma_block": "Blok magmatu",
  "block.minecraft.mangrove_button": "Kořenovníkové tlačítko",
  "block.minecraft.mangrove_door": "Kořenovníkové dveře",
  "block.minecraft.mangrove_fence": "Kořenovníkový plot",
  "block.minecraft.mangrove_fence_gate": "Kořenovníková branka",
  "block.minecraft.mangrove_hanging_sign": "Kořenovníková závěsná cedule",
  "block.minecraft.mangrove_leaves": "Kořenovníkové listí",
  "block.minecraft.mangrove_log": "Kořenovníkový kmen",
  "block.minecraft.mangrove_planks": "Kořenovníková prkna",
  "block.minecraft.mangrove_pressure_plate": "Nášlapná deska z kořenovníkového dřeva",
  "block.minecraft.mangrove_propagule": "Kořenovníkový výhonek",
  "block.minecraft.mangrove_roots": "Kořeny kořenovníku",
  "block.minecraft.mangrove_shelf": "Kořenovníková polička",
  "block.minecraft.mangrove_sign": "Kořenovníková cedule",
  "block.minecraft.mangrove_slab": "Kořenovníkový půlblok",
  "block.minecraft.mangrove_stairs": "Kořenovníkové schody",
  "block.minecraft.mangrove_trapdoor": "Kořenovníkový poklop",
  "block.minecraft.mangrove_wall_hanging_sign": "Kořenovníková závěsná cedule na zdi",
  "block.minecraft.mangrove_wall_sign": "Kořenovníková cedule na zdi",
  "block.minecraft.mangrove_wood": "Kořenovníkové dřevo",
  "block.minecraft.medium_amethyst_bud": "Střední trs ametystů",
  "block.minecraft.melon": "Meloun",
  "block.minecraft.melon_stem": "Stonek melounu",
  "block.minecraft.moss_block": "Blok mechu",
  "block.minecraft.moss_carpet": "Mechový koberec",
  "block.minecraft.mossy_cobblestone": "Kamení porostlé mechem",
  "block.minecraft.mossy_cobblestone_slab": "Omšelý půlblok z kamení",
  "block.minecraft.mossy_cobblestone_stairs": "Omšelé schody z kamení",
  "block.minecraft.mossy_cobblestone_wall": "Omšelá zídka z kamení",
  "block.minecraft.mossy_stone_brick_slab": "Omšelý půlblok z kamenných cihel",
  "block.minecraft.mossy_stone_brick_stairs": "Omšelé schody z kamenných cihel",
  "block.minecraft.mossy_stone_brick_wall": "Omšelá zídka z kamenných cihel",
  "block.minecraft.mossy_stone_bricks": "Omšelé kamenné cihly",
  "block.minecraft.moving_piston": "Pohybující se blok",
  "block.minecraft.mud": "Bahno",
  "block.minecraft.mud_brick_slab": "Vepřovicový půlblok",
  "block.minecraft.mud_brick_stairs": "Vepřovicové schody",
  "block.minecraft.mud_brick_wall": "Vepřovicová zídka",
  "block.minecraft.mud_bricks": "Vepřovice",
  "block.minecraft.muddy_mangrove_roots": "Zabahněné kořeny kořenovníku",
  "block.minecraft.mushroom_stem": "Třeň",
  "block.minecraft.mycelium": "Podhoubí",
  "block.minecraft.nether_brick_fence": "Plot z netherových cihel",
  "block.minecraft.nether_brick_slab": "Půlblok z netherových cihel",
  "block.minecraft.nether_brick_stairs": "Schody z netherových cihel",
  "block.minecraft.nether_brick_wall": "Zídka z netherových cihel",
  "block.minecraft.nether_bricks": "Netherové cihly",
  "block.minecraft.nether_gold_ore": "Netherová zlatá ruda",
  "block.minecraft.nether_portal": "Portál do Netheru",
  "block.minecraft.nether_quartz_ore": "Ložisko netherového křemene",
  "block.minecraft.nether_sprouts": "Netherové výhonky",
  "block.minecraft.nether_wart": "Bradavičník",
  "block.minecraft.nether_wart_block": "Blok bradavičníku",
  "block.minecraft.netherite_block": "Blok netheritu",
  "block.minecraft.netherrack": "Netherová suť",
  "block.minecraft.note_block": "Hudební blok",
  "block.minecraft.oak_button": "Dubové tlačítko",
  "block.minecraft.oak_door": "Dubové dveře",
  "block.minecraft.oak_fence": "Dubový plot",
  "block.minecraft.oak_fence_gate": "Dubová branka",
  "block.minecraft.oak_hanging_sign": "Dubová závěsná cedule",
  "block.minecraft.oak_leaves": "Dubové listí",
  "block.minecraft.oak_log": "Dubový kmen",
  "block.minecraft.oak_planks": "Dubová prkna",
  "block.minecraft.oak_pressure_plate": "Dubová nášlapná deska",
  "block.minecraft.oak_sapling": "Sazenice dubu",
  "block.minecraft.oak_shelf": "Dubová polička",
  "block.minecraft.oak_sign": "Dubová cedule",
  "block.minecraft.oak_slab": "Dubový půlblok",
  "block.minecraft.oak_stairs": "Dubové schody",
  "block.minecraft.oak_trapdoor": "Dubový poklop",
  "block.minecraft.oak_wall_hanging_sign": "Dubová závěsná cedule na zdi",
  "block.minecraft.oak_wall_sign": "Dubová cedule na zdi",
  "block.minecraft.oak_wood": "Dubové dřevo",
  "block.minecraft.observer": "Detektor změn",
  "block.minecraft.obsidian": "Obsidián",
  "block.minecraft.ochre_froglight": "Okrový žabosvit",
  "block.minecraft.ominous_banner": "Zlověstný prapor",
  "block.minecraft.open_eyeblossom": "Otevřená očenka",
  "block.minecraft.orange_banner": "Oranžový prapor",
  "block.minecraft.orange_bed": "Oranžová postel",
  "block.minecraft.orange_candle": "Oranžová svíčka",
  "block.minecraft.orange_candle_cake": "Dort s oranžovou svíčkou",
  "block.minecraft.orange_carpet": "Oranžový koberec",
  "block.minecraft.orange_concrete": "Oranžový beton",
  "block.minecraft.orange_concrete_powder": "Oranžový cement",
  "block.minecraft.orange_glazed_terracotta": "Oranžová glazovaná terakota",
  "block.minecraft.orange_shulker_box": "Oranžová shulkerova schránka",
  "block.minecraft.orange_stained_glass": "Oranžové sklo",
  "block.minecraft.orange_stained_glass_pane": "Tabulka oranžového skla",
  "block.minecraft.orange_terracotta": "Oranžová terakota",
  "block.minecraft.orange_tulip": "Oranžový tulipán",
  "block.minecraft.orange_wool": "Oranžová vlna",
  "block.minecraft.oxeye_daisy": "Kopretina",
  "block.minecraft.oxidized_chiseled_copper": "Opracovaná měď s měděnkou",
  "block.minecraft.oxidized_copper": "Měď pokrytá měděnkou",
  "block.minecraft.oxidized_copper_bars": "Měděné mříže s měděnkou",
  "block.minecraft.oxidized_copper_bulb": "Měděná lampa s měděnkou",
  "block.minecraft.oxidized_copper_chain": "Měděný řetěz s měděnkou",
  "block.minecraft.oxidized_copper_chest": "Měděná truhla s měděnkou",
  "block.minecraft.oxidized_copper_door": "Měděné dveře s měděnkou",
  "block.minecraft.oxidized_copper_golem_statue": "Soška měděného golema s měděnkou",
  "block.minecraft.oxidized_copper_grate": "Měděný rošt s měděnkou",
  "block.minecraft.oxidized_copper_lantern": "Měděná lucerna s měděnkou",
  "block.minecraft.oxidized_copper_trapdoor": "Měděný poklop s měděnkou",
  "block.minecraft.oxidized_cut_copper": "Tepaná měď pokrytá měděnkou",
  "block.minecraft.oxidized_cut_copper_slab": "Tepaný půlblok pokrytý měděnkou",
  "block.minecraft.oxidized_cut_copper_stairs": "Tepané schody pokryté měděnkou",
  "block.minecraft.oxidized_lightning_rod": "Hromosvod s měděnkou",
  "block.minecraft.packed_ice": "Hutný led",
  "block.minecraft.packed_mud": "Hutné bahno",
  "block.minecraft.pale_hanging_moss": "Bledý převislý mech",
  "block.minecraft.pale_moss_block": "Blok bledého mechu",
  "block.minecraft.pale_moss_carpet": "Koberec z bledého mechu",
  "block.minecraft.pale_oak_button": "Tlačítko z bledého dubu",
  "block.minecraft.pale_oak_door": "Dveře z bledého dubu",
  "block.minecraft.pale_oak_fence": "Plot z bledého dubu",
  "block.minecraft.pale_oak_fence_gate": "Branka z bledého dubu",
  "block.minecraft.pale_oak_hanging_sign": "Závěsná cedule z bledého dubu",
  "block.minecraft.pale_oak_leaves": "Listí bledého dubu",
  "block.minecraft.pale_oak_log": "Kmen z bledého dubu",
  "block.minecraft.pale_oak_planks": "Prkna z bledého dubu",
  "block.minecraft.pale_oak_pressure_plate": "Nášlapná deska z bledého dubu",
  "block.minecraft.pale_oak_sapling": "Sazenice bledého dubu",
  "block.minecraft.pale_oak_shelf": "Polička z bledého dubu",
  "block.minecraft.pale_oak_sign": "Cedule z bledého dubu",
  "block.minecraft.pale_oak_slab": "Půlblok z bledého dubu",
  "block.minecraft.pale_oak_stairs": "Schody z bledého dubu",
  "block.minecraft.pale_oak_trapdoor": "Poklop z bledého dubu",
  "block.minecraft.pale_oak_wall_hanging_sign": "Závěsná cedule z bledého dubu na zdi",
  "block.minecraft.pale_oak_wall_sign": "Cedule z bledého dubu na zdi",
  "block.minecraft.pale_oak_wood": "Dřevo z bledého dubu",
  "block.minecraft.pearlescent_froglight": "Perleťový žabosvit",
  "block.minecraft.peony": "Pivoňka",
  "block.minecraft.petrified_oak_slab": "Zkamenělý dubový půlblok",
  "block.minecraft.piglin_head": "Hlava piglina",
  "block.minecraft.piglin_wall_head": "Hlava piglina na zdi",
  "block.minecraft.pink_banner": "Růžový prapor",
  "block.minecraft.pink_bed": "Růžová postel",
  "block.minecraft.pink_candle": "Růžová svíčka",
  "block.minecraft.pink_candle_cake": "Dort s růžovou svíčkou",
  "block.minecraft.pink_carpet": "Růžový koberec",
  "block.minecraft.pink_concrete": "Růžový beton",
  "block.minecraft.pink_concrete_powder": "Růžový cement",
  "block.minecraft.pink_glazed_terracotta": "Růžová glazovaná terakota",
  "block.minecraft.pink_petals": "Růžové kvítí",
  "block.minecraft.pink_shulker_box": "Růžová shulkerova schránka",
  "block.minecraft.pink_stained_glass": "Růžové sklo",
  "block.minecraft.pink_stained_glass_pane": "Tabulka růžového skla",
  "block.minecraft.pink_terracotta": "Růžová terakota",
  "block.minecraft.pink_tulip": "Růžový tulipán",
  "block.minecraft.pink_wool": "Růžová vlna",
  "block.minecraft.piston": "Píst",
  "block.minecraft.piston_head": "Hlava pístu",
  "block.minecraft.pitcher_crop": "Rostoucí džbánovka",
  "block.minecraft.pitcher_plant": "Džbánovka",
  "block.minecraft.player_head": "Hlava hráče",
  "block.minecraft.player_head.named": "Hlava hráče %s",
  "block.minecraft.player_wall_head": "Hlava hráče na zdi",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Špička krápníku",
  "block.minecraft.polished_andesite": "Leštěný andezit",
  "block.minecraft.polished_andesite_slab": "Půlblok z leštěného andezitu",
  "block.minecraft.polished_andesite_stairs": "Schody z leštěného andezitu",
  "block.minecraft.polished_basalt": "Leštěný čedič",
  "block.minecraft.polished_blackstone": "Leštěný černokámen",
  "block.minecraft.polished_blackstone_brick_slab": "Půlblok z cihel z leštěného černokamene",
  "block.minecraft.polished_blackstone_brick_stairs": "Schody z cihel z leštěného černokamene",
  "block.minecraft.polished_blackstone_brick_wall": "Zídka z cihel z leštěného černokamene",
  "block.minecraft.polished_blackstone_bricks": "Cihly z leštěného černokamene",
  "block.minecraft.polished_blackstone_button": "Tlačítko z leštěného černokamene",
  "block.minecraft.polished_blackstone_pressure_plate": "Nášlapná deska z leštěného černokamene",
  "block.minecraft.polished_blackstone_slab": "Půlblok z leštěného černokamene",
  "block.minecraft.polished_blackstone_stairs": "Schody z leštěného černokamene",
  "block.minecraft.polished_blackstone_wall": "Zídka z leštěného černokamene",
  "block.minecraft.polished_deepslate": "Leštěná břidlice",
  "block.minecraft.polished_deepslate_slab": "Půlblok z leštěné břidlice",
  "block.minecraft.polished_deepslate_stairs": "Schody z leštěné břidlice",
  "block.minecraft.polished_deepslate_wall": "Zídka z leštěné břidlice",
  "block.minecraft.polished_diorite": "Leštěný diorit",
  "block.minecraft.polished_diorite_slab": "Půlblok z leštěného dioritu",
  "block.minecraft.polished_diorite_stairs": "Schody z leštěného dioritu",
  "block.minecraft.polished_granite": "Leštěná žula",
  "block.minecraft.polished_granite_slab": "Půlblok z leštěné žuly",
  "block.minecraft.polished_granite_stairs": "Schody z leštěné žuly",
  "block.minecraft.polished_tuff": "Leštěný tuf",
  "block.minecraft.polished_tuff_slab": "Půlblok z leštěného tufu",
  "block.minecraft.polished_tuff_stairs": "Schody z leštěného tufu",
  "block.minecraft.polished_tuff_wall": "Zídka z leštěného tufu",
  "block.minecraft.poppy": "Vlčí mák",
  "block.minecraft.potatoes": "Brambory",
  "block.minecraft.potted_acacia_sapling": "Sazenice akácie v květináči",
  "block.minecraft.potted_allium": "Česnek v květináči",
  "block.minecraft.potted_azalea_bush": "Azalka v květináči",
  "block.minecraft.potted_azure_bluet": "Houstonie modrá v květináči",
  "block.minecraft.potted_bamboo": "Bambus v květináči",
  "block.minecraft.potted_birch_sapling": "Sazenice břízy v květináči",
  "block.minecraft.potted_blue_orchid": "Modrá orchidej v květináči",
  "block.minecraft.potted_brown_mushroom": "Hřib v květináči",
  "block.minecraft.potted_cactus": "Kaktus v květináči",
  "block.minecraft.potted_cherry_sapling": "Sazenice třešně v květináči",
  "block.minecraft.potted_closed_eyeblossom": "Uzavřená očenka v květináči",
  "block.minecraft.potted_cornflower": "Chrpa v květináči",
  "block.minecraft.potted_crimson_fungus": "Karmínová houba v květináči",
  "block.minecraft.potted_crimson_roots": "Karmínové kořínky v květináči",
  "block.minecraft.potted_dandelion": "Pampeliška v květináči",
  "block.minecraft.potted_dark_oak_sapling": "Sazenice tmavého dubu v květináči",
  "block.minecraft.potted_dead_bush": "Suchý keř v květináči",
  "block.minecraft.potted_fern": "Kapradina v květináči",
  "block.minecraft.potted_flowering_azalea_bush": "Kvetoucí azalka v květináči",
  "block.minecraft.potted_golden_dandelion": "Zlatá pampeliška v květináči",
  "block.minecraft.potted_jungle_sapling": "Sazenice tropického stromu v květináči",
  "block.minecraft.potted_lily_of_the_valley": "Konvalinka v květináči",
  "block.minecraft.potted_mangrove_propagule": "Kořenovníkový výhonek v květináči",
  "block.minecraft.potted_oak_sapling": "Sazenice dubu v květináči",
  "block.minecraft.potted_open_eyeblossom": "Otevřená očenka v květináči",
  "block.minecraft.potted_orange_tulip": "Oranžový tulipán v květináči",
  "block.minecraft.potted_oxeye_daisy": "Kopretina v květináči",
  "block.minecraft.potted_pale_oak_sapling": "Sazenice bledého dubu v květináči",
  "block.minecraft.potted_pink_tulip": "Růžový tulipán v květináči",
  "block.minecraft.potted_poppy": "Vlčí mák v květináči",
  "block.minecraft.potted_red_mushroom": "Muchomůrka v květináči",
  "block.minecraft.potted_red_tulip": "Červený tulipán v květináči",
  "block.minecraft.potted_spruce_sapling": "Sazenice smrku v květináči",
  "block.minecraft.potted_torchflower": "Plamněnka v květináči",
  "block.minecraft.potted_warped_fungus": "Přízračná houba v květináči",
  "block.minecraft.potted_warped_roots": "Přízračné kořínky v květináči",
  "block.minecraft.potted_white_tulip": "Bílý tulipán v květináči",
  "block.minecraft.potted_wither_rose": "Witherova růže v květináči",
  "block.minecraft.powder_snow": "Prašan",
  "block.minecraft.powder_snow_cauldron": "Kotel s prašanem",
  "block.minecraft.powered_rail": "Napájená kolej",
  "block.minecraft.prismarine": "Prismarín",
  "block.minecraft.prismarine_brick_slab": "Půlblok z prismarínových cihel",
  "block.minecraft.prismarine_brick_stairs": "Schody z prismarínových cihel",
  "block.minecraft.prismarine_bricks": "Prismarínové cihly",
  "block.minecraft.prismarine_slab": "Prismarínový půlblok",
  "block.minecraft.prismarine_stairs": "Prismarínové schody",
  "block.minecraft.prismarine_wall": "Prismarínová zídka",
  "block.minecraft.pumpkin": "Dýně",
  "block.minecraft.pumpkin_stem": "Dýňový stonek",
  "block.minecraft.purple_banner": "Fialový prapor",
  "block.minecraft.purple_bed": "Fialová postel",
  "block.minecraft.purple_candle": "Fialová svíčka",
  "block.minecraft.purple_candle_cake": "Dort s fialovou svíčkou",
  "block.minecraft.purple_carpet": "Fialový koberec",
  "block.minecraft.purple_concrete": "Fialový beton",
  "block.minecraft.purple_concrete_powder": "Fialový cement",
  "block.minecraft.purple_glazed_terracotta": "Fialová glazovaná terakota",
  "block.minecraft.purple_shulker_box": "Fialová shulkerova schránka",
  "block.minecraft.purple_stained_glass": "Fialové sklo",
  "block.minecraft.purple_stained_glass_pane": "Tabulka fialového skla",
  "block.minecraft.purple_terracotta": "Fialová terakota",
  "block.minecraft.purple_wool": "Fialová vlna",
  "block.minecraft.purpur_block": "Blok purpuru",
  "block.minecraft.purpur_pillar": "Purpurový pilíř",
  "block.minecraft.purpur_slab": "Purpurový půlblok",
  "block.minecraft.purpur_stairs": "Purpurové schody",
  "block.minecraft.quartz_block": "Blok křemene",
  "block.minecraft.quartz_bricks": "Křemenné cihly",
  "block.minecraft.quartz_pillar": "Křemenný pilíř",
  "block.minecraft.quartz_slab": "Křemenný půlblok",
  "block.minecraft.quartz_stairs": "Křemenné schody",
  "block.minecraft.rail": "Kolej",
  "block.minecraft.raw_copper_block": "Blok vytěžené mědi",
  "block.minecraft.raw_gold_block": "Blok vytěženého zlata",
  "block.minecraft.raw_iron_block": "Blok vytěženého železa",
  "block.minecraft.red_banner": "Červený prapor",
  "block.minecraft.red_bed": "Červená postel",
  "block.minecraft.red_candle": "Červená svíčka",
  "block.minecraft.red_candle_cake": "Dort s červenou svíčkou",
  "block.minecraft.red_carpet": "Červený koberec",
  "block.minecraft.red_concrete": "Červený beton",
  "block.minecraft.red_concrete_powder": "Červený cement",
  "block.minecraft.red_glazed_terracotta": "Červená glazovaná terakota",
  "block.minecraft.red_mushroom": "Muchomůrka",
  "block.minecraft.red_mushroom_block": "Muchomůrkový blok",
  "block.minecraft.red_nether_brick_slab": "Půlblok z rudých netherových cihel",
  "block.minecraft.red_nether_brick_stairs": "Schody z rudých netherových cihel",
  "block.minecraft.red_nether_brick_wall": "Zídka z rudých netherových cihel",
  "block.minecraft.red_nether_bricks": "Rudé netherové cihly",
  "block.minecraft.red_sand": "Rudý písek",
  "block.minecraft.red_sandstone": "Rudý pískovec",
  "block.minecraft.red_sandstone_slab": "Půlblok z rudého pískovce",
  "block.minecraft.red_sandstone_stairs": "Schody z rudého pískovce",
  "block.minecraft.red_sandstone_wall": "Zídka z rudého pískovce",
  "block.minecraft.red_shulker_box": "Červená shulkerova schránka",
  "block.minecraft.red_stained_glass": "Červené sklo",
  "block.minecraft.red_stained_glass_pane": "Tabulka červeného skla",
  "block.minecraft.red_terracotta": "Červená terakota",
  "block.minecraft.red_tulip": "Červený tulipán",
  "block.minecraft.red_wool": "Červená vlna",
  "block.minecraft.redstone_block": "Redstonový blok",
  "block.minecraft.redstone_lamp": "Redstonová lampa",
  "block.minecraft.redstone_ore": "Redstonové ložisko",
  "block.minecraft.redstone_torch": "Redstonová louč",
  "block.minecraft.redstone_wall_torch": "Redstonová louč na zdi",
  "block.minecraft.redstone_wire": "Redstonový vodič",
  "block.minecraft.reinforced_deepslate": "Vyztužená břidlice",
  "block.minecraft.repeater": "Redstonový zesilovač",
  "block.minecraft.repeating_command_block": "Opakovací příkazový blok",
  "block.minecraft.resin_block": "Blok pryskyřice",
  "block.minecraft.resin_brick_slab": "Půlblok z pryskyřice",
  "block.minecraft.resin_brick_stairs": "Schody z pryskyřice",
  "block.minecraft.resin_brick_wall": "Zídka z pryskyřice",
  "block.minecraft.resin_bricks": "Cihly z pryskyřice",
  "block.minecraft.resin_clump": "Hrudka pryskyřice",
  "block.minecraft.respawn_anchor": "Kotva oživení",
  "block.minecraft.rooted_dirt": "Prorostlá hlína",
  "block.minecraft.rose_bush": "Keř růží",
  "block.minecraft.sand": "Písek",
  "block.minecraft.sandstone": "Pískovec",
  "block.minecraft.sandstone_slab": "Pískovcový půlblok",
  "block.minecraft.sandstone_stairs": "Pískovcové schody",
  "block.minecraft.sandstone_wall": "Pískovcová zídka",
  "block.minecraft.scaffolding": "Lešení",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkový katalyzátor",
  "block.minecraft.sculk_sensor": "Sculkové čidlo",
  "block.minecraft.sculk_shrieker": "Sculkový kvílák",
  "block.minecraft.sculk_vein": "Sculková žíla",
  "block.minecraft.sea_lantern": "Mořská lucerna",
  "block.minecraft.sea_pickle": "Ohnivka",
  "block.minecraft.seagrass": "Mořská tráva",
  "block.minecraft.set_spawn": "Místo oživení nastaveno",
  "block.minecraft.short_dry_grass": "Nízká suchá tráva",
  "block.minecraft.short_grass": "Nízká tráva",
  "block.minecraft.shroomlight": "Světlohubka",
  "block.minecraft.shulker_box": "Shulkerova schránka",
  "block.minecraft.skeleton_skull": "Lebka kostlivce",
  "block.minecraft.skeleton_wall_skull": "Lebka kostlivce na zdi",
  "block.minecraft.slime_block": "Blok slizu",
  "block.minecraft.small_amethyst_bud": "Malý trs ametystů",
  "block.minecraft.small_dripleaf": "Malá krápenka",
  "block.minecraft.smithing_table": "Kovářský stůl",
  "block.minecraft.smoker": "Trouba",
  "block.minecraft.smooth_basalt": "Hladký čedič",
  "block.minecraft.smooth_quartz": "Blok hladkého křemene",
  "block.minecraft.smooth_quartz_slab": "Půlblok z hladkého křemene",
  "block.minecraft.smooth_quartz_stairs": "Schody z hladkého křemene",
  "block.minecraft.smooth_red_sandstone": "Vyhlazený rudý pískovec",
  "block.minecraft.smooth_red_sandstone_slab": "Půlblok z vyhlazeného rudého pískovce",
  "block.minecraft.smooth_red_sandstone_stairs": "Schody z vyhlazeného rudého pískovce",
  "block.minecraft.smooth_sandstone": "Vyhlazený pískovec",
  "block.minecraft.smooth_sandstone_slab": "Půlblok z vyhlazeného pískovce",
  "block.minecraft.smooth_sandstone_stairs": "Schody z vyhlazeného pískovce",
  "block.minecraft.smooth_stone": "Hladký kámen",
  "block.minecraft.smooth_stone_slab": "Půlblok z hladkého kamene",
  "block.minecraft.sniffer_egg": "Čmuchalí vejce",
  "block.minecraft.snow": "Sníh",
  "block.minecraft.snow_block": "Blok sněhu",
  "block.minecraft.soul_campfire": "Táborák s ohněm duší",
  "block.minecraft.soul_fire": "Oheň duší",
  "block.minecraft.soul_lantern": "Lucerna duší",
  "block.minecraft.soul_sand": "Písek duší",
  "block.minecraft.soul_soil": "Půda duší",
  "block.minecraft.soul_torch": "Louč duší",
  "block.minecraft.soul_wall_torch": "Louč duší na zdi",
  "block.minecraft.spawn.not_valid": "Nemáš žádnou postel ani kotvu oživení, nebo jsou nepřístupné",
  "block.minecraft.spawner": "Líheň",
  "block.minecraft.spawner.desc1": "Interakce s vajíčkem se stvořením:",
  "block.minecraft.spawner.desc2": "Nastaví typ stvoření",
  "block.minecraft.sponge": "Mořská houba",
  "block.minecraft.spore_blossom": "Prášenka",
  "block.minecraft.spruce_button": "Smrkové tlačítko",
  "block.minecraft.spruce_door": "Smrkové dveře",
  "block.minecraft.spruce_fence": "Smrkový plot",
  "block.minecraft.spruce_fence_gate": "Smrková branka",
  "block.minecraft.spruce_hanging_sign": "Smrková závěsná cedule",
  "block.minecraft.spruce_leaves": "Smrkové jehličí",
  "block.minecraft.spruce_log": "Smrkový kmen",
  "block.minecraft.spruce_planks": "Smrková prkna",
  "block.minecraft.spruce_pressure_plate": "Smrková nášlapná deska",
  "block.minecraft.spruce_sapling": "Sazenice smrku",
  "block.minecraft.spruce_shelf": "Smrková polička",
  "block.minecraft.spruce_sign": "Smrková cedule",
  "block.minecraft.spruce_slab": "Smrkový půlblok",
  "block.minecraft.spruce_stairs": "Smrkové schody",
  "block.minecraft.spruce_trapdoor": "Smrkový poklop",
  "block.minecraft.spruce_wall_hanging_sign": "Smrková závěsná cedule na zdi",
  "block.minecraft.spruce_wall_sign": "Smrková cedule na zdi",
  "block.minecraft.spruce_wood": "Smrkové dřevo",
  "block.minecraft.sticky_piston": "Lepivý píst",
  "block.minecraft.stone": "Kámen",
  "block.minecraft.stone_brick_slab": "Půlblok z kamenných cihel",
  "block.minecraft.stone_brick_stairs": "Schody z kamenných cihel",
  "block.minecraft.stone_brick_wall": "Zídka z kamenných cihel",
  "block.minecraft.stone_bricks": "Kamenné cihly",
  "block.minecraft.stone_button": "Kamenné tlačítko",
  "block.minecraft.stone_pressure_plate": "Kamenná nášlapná deska",
  "block.minecraft.stone_slab": "Kamenný půlblok",
  "block.minecraft.stone_stairs": "Kamenné schody",
  "block.minecraft.stonecutter": "Řezačka kamene",
  "block.minecraft.stripped_acacia_log": "Oloupaný akáciový kmen",
  "block.minecraft.stripped_acacia_wood": "Oloupané akáciové dřevo",
  "block.minecraft.stripped_bamboo_block": "Blok oloupaného bambusu",
  "block.minecraft.stripped_birch_log": "Oloupaný březový kmen",
  "block.minecraft.stripped_birch_wood": "Oloupané březové dřevo",
  "block.minecraft.stripped_cherry_log": "Oloupaný třešňový kmen",
  "block.minecraft.stripped_cherry_wood": "Oloupané třešňové dřevo",
  "block.minecraft.stripped_crimson_hyphae": "Oloupaná karmínová stélka",
  "block.minecraft.stripped_crimson_stem": "Oloupaná karmínová třeň",
  "block.minecraft.stripped_dark_oak_log": "Oloupaný kmen z tmavého dubu",
  "block.minecraft.stripped_dark_oak_wood": "Oloupané dřevo z tmavého dubu",
  "block.minecraft.stripped_jungle_log": "Oloupaný kmen z tropického stromu",
  "block.minecraft.stripped_jungle_wood": "Oloupané tropické dřevo",
  "block.minecraft.stripped_mangrove_log": "Oloupaný kořenovníkový kmen",
  "block.minecraft.stripped_mangrove_wood": "Oloupané kořenovníkové dřevo",
  "block.minecraft.stripped_oak_log": "Oloupaný dubový kmen",
  "block.minecraft.stripped_oak_wood": "Oloupané dubové dřevo",
  "block.minecraft.stripped_pale_oak_log": "Oloupaný kmen z bledého dubu",
  "block.minecraft.stripped_pale_oak_wood": "Oloupané dřevo z bledého dubu",
  "block.minecraft.stripped_spruce_log": "Oloupaný smrkový kmen",
  "block.minecraft.stripped_spruce_wood": "Oloupané smrkové dřevo",
  "block.minecraft.stripped_warped_hyphae": "Oloupaná přízračná stélka",
  "block.minecraft.stripped_warped_stem": "Oloupaná přízračná třeň",
  "block.minecraft.structure_block": "Konstrukční blok",
  "block.minecraft.structure_void": "Konstrukční void",
  "block.minecraft.sugar_cane": "Cukrová třtina",
  "block.minecraft.sunflower": "Slunečnice",
  "block.minecraft.suspicious_gravel": "Zvláštní štěrk",
  "block.minecraft.suspicious_sand": "Zvláštní písek",
  "block.minecraft.sweet_berry_bush": "Keř sladkých bobulí",
  "block.minecraft.tall_dry_grass": "Vysoká suchá tráva",
  "block.minecraft.tall_grass": "Vysoká tráva",
  "block.minecraft.tall_seagrass": "Vysoká mořská tráva",
  "block.minecraft.target": "Terč",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Testovací blok",
  "block.minecraft.test_instance_block": "Blok testovací instance",
  "block.minecraft.tinted_glass": "Kouřové sklo",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Výbuchy TNT jsou vypnuty",
  "block.minecraft.torch": "Louč",
  "block.minecraft.torchflower": "Plamněnka",
  "block.minecraft.torchflower_crop": "Rostoucí plamněnka",
  "block.minecraft.trapped_chest": "Nástražná truhla",
  "block.minecraft.trial_spawner": "Líheň klání",
  "block.minecraft.tripwire": "Nástražný drát",
  "block.minecraft.tripwire_hook": "Uchycení nástražného drátu",
  "block.minecraft.tube_coral": "Varhanitkový korál",
  "block.minecraft.tube_coral_block": "Blok varhanitkového korálu",
  "block.minecraft.tube_coral_fan": "Vějíř varhanitkového korálu",
  "block.minecraft.tube_coral_wall_fan": "Vějíř varhanitkového korálu na zdi",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Půlblok z tufových cihel",
  "block.minecraft.tuff_brick_stairs": "Schody z tufových cihel",
  "block.minecraft.tuff_brick_wall": "Zídka z tufových cihel",
  "block.minecraft.tuff_bricks": "Tufové cihly",
  "block.minecraft.tuff_slab": "Tufový půlblok",
  "block.minecraft.tuff_stairs": "Tufové schody",
  "block.minecraft.tuff_wall": "Tufová zídka",
  "block.minecraft.turtle_egg": "Želví vajíčko",
  "block.minecraft.twisting_vines": "Přízračná liána",
  "block.minecraft.twisting_vines_plant": "Stonek přízračné liány",
  "block.minecraft.vault": "Pokladnice",
  "block.minecraft.verdant_froglight": "Nazelenalý žabosvit",
  "block.minecraft.vine": "Liána",
  "block.minecraft.void_air": "Vzduch",
  "block.minecraft.wall_torch": "Louč na zdi",
  "block.minecraft.warped_button": "Přízračné tlačítko",
  "block.minecraft.warped_door": "Přízračné dveře",
  "block.minecraft.warped_fence": "Přízračný plot",
  "block.minecraft.warped_fence_gate": "Přízračná branka",
  "block.minecraft.warped_fungus": "Přízračná houba",
  "block.minecraft.warped_hanging_sign": "Přízračná závěsná cedule",
  "block.minecraft.warped_hyphae": "Přízračná stélka",
  "block.minecraft.warped_nylium": "Přízračné podhoubí",
  "block.minecraft.warped_planks": "Přízračná prkna",
  "block.minecraft.warped_pressure_plate": "Přízračná nášlapná deska",
  "block.minecraft.warped_roots": "Přízračné kořínky",
  "block.minecraft.warped_shelf": "Přízračná polička",
  "block.minecraft.warped_sign": "Přízračná cedule",
  "block.minecraft.warped_slab": "Přízračný půlblok",
  "block.minecraft.warped_stairs": "Přízračné schody",
  "block.minecraft.warped_stem": "Přízračná třeň",
  "block.minecraft.warped_trapdoor": "Přízračný poklop",
  "block.minecraft.warped_wall_hanging_sign": "Přízračná závěsná cedule na zdi",
  "block.minecraft.warped_wall_sign": "Přízračná cedule na zdi",
  "block.minecraft.warped_wart_block": "Blok přízračného bradavičníku",
  "block.minecraft.water": "Voda",
  "block.minecraft.water_cauldron": "Kotel s vodou",
  "block.minecraft.waxed_chiseled_copper": "Navoskovaná opracovaná měď",
  "block.minecraft.waxed_copper_bars": "Navoskované měděné mříže",
  "block.minecraft.waxed_copper_block": "Navoskovaný blok mědi",
  "block.minecraft.waxed_copper_bulb": "Navoskovaná měděná lampa",
  "block.minecraft.waxed_copper_chain": "Navoskovaný měděný řetěz",
  "block.minecraft.waxed_copper_chest": "Navoskovaná měděná truhla",
  "block.minecraft.waxed_copper_door": "Navoskované měděné dveře",
  "block.minecraft.waxed_copper_golem_statue": "Navoskovaná soška měděného golema",
  "block.minecraft.waxed_copper_grate": "Navoskovaný měděný rošt",
  "block.minecraft.waxed_copper_lantern": "Navoskovaná měděná lucerna",
  "block.minecraft.waxed_copper_trapdoor": "Navoskovaný měděný poklop",
  "block.minecraft.waxed_cut_copper": "Navoskovaná tepaná měď",
  "block.minecraft.waxed_cut_copper_slab": "Navoskovaný půlblok z tepané mědi",
  "block.minecraft.waxed_cut_copper_stairs": "Navoskované schody z tepané mědi",
  "block.minecraft.waxed_exposed_chiseled_copper": "Navoskovaná opracovaná měď s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper": "Navoskovaná měď s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper_bars": "Navoskované měděné mříže s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper_bulb": "Navoskovaná měděná lampa s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper_chain": "Navoskovaný měděný řetěz s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper_chest": "Navoskovaná měděná truhla s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper_door": "Navoskované měděné dveře s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Navoskovaná soška měděného golema s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper_grate": "Navoskovaný měděný rošt s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper_lantern": "Navoskovaná měděná lucerna s lehkou měděnkou",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Navoskovaný měděný poklop s lehkou měděnkou",
  "block.minecraft.waxed_exposed_cut_copper": "Navoskovaná tepaná měď s lehkou měděnkou",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Navoskovaný tepaný půlblok s lehkou měděnkou",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Navoskované tepané schody s lehkou měděnkou",
  "block.minecraft.waxed_exposed_lightning_rod": "Navoskovaný hromosvod s lehkou měděnkou",
  "block.minecraft.waxed_lightning_rod": "Navoskovaný hromosvod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Navoskovaná opracovaná měď s měděnkou",
  "block.minecraft.waxed_oxidized_copper": "Navoskovaná měď pokrytá měděnkou",
  "block.minecraft.waxed_oxidized_copper_bars": "Navoskované měděné mříže s měděnkou",
  "block.minecraft.waxed_oxidized_copper_bulb": "Navoskovaná měděná lampa s měděnkou",
  "block.minecraft.waxed_oxidized_copper_chain": "Navoskovaný měděný řetěz s měděnkou",
  "block.minecraft.waxed_oxidized_copper_chest": "Navoskovaná měděná truhla s měděnkou",
  "block.minecraft.waxed_oxidized_copper_door": "Navoskované měděné dveře s měděnkou",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Navoskovaná soška měděného golema s měděnkou",
  "block.minecraft.waxed_oxidized_copper_grate": "Navoskovaný měděný rošt s měděnkou",
  "block.minecraft.waxed_oxidized_copper_lantern": "Navoskovaná měděná lucerna s měděnkou",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Navoskovaný měděný poklop s měděnkou",
  "block.minecraft.waxed_oxidized_cut_copper": "Navoskovaná tepaná měď pokrytá měděnkou",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Navoskovaný půlblok pokrytý měděnkou",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Navoskované schody pokryté měděnkou",
  "block.minecraft.waxed_oxidized_lightning_rod": "Navoskovaný hromosvod s měděnkou",
  "block.minecraft.waxed_weathered_chiseled_copper": "Navoskovaná opracovaná měď se střední měděnkou",
  "block.minecraft.waxed_weathered_copper": "Navoskovaná měď pokrytá střední měděnkou",
  "block.minecraft.waxed_weathered_copper_bars": "Navoskované měděné mříže se střední měděnkou",
  "block.minecraft.waxed_weathered_copper_bulb": "Navoskovaná měděná lampa se střední měděnkou",
  "block.minecraft.waxed_weathered_copper_chain": "Navoskovaný měděný řetěz se střední měděnkou",
  "block.minecraft.waxed_weathered_copper_chest": "Navoskovaná měděná truhla se střední měděnkou",
  "block.minecraft.waxed_weathered_copper_door": "Navoskované měděné dveře se střední měděnkou",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Navoskovaná soška měděného golema se střední měděnkou",
  "block.minecraft.waxed_weathered_copper_grate": "Navoskovaný měděný rošt se střední měděnkou",
  "block.minecraft.waxed_weathered_copper_lantern": "Navoskovaná měděná lucerna se střední měděnkou",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Navoskovaný měděný poklop se střední měděnkou",
  "block.minecraft.waxed_weathered_cut_copper": "Navoskovaná tepaná měď pokrytá střední měděnkou",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Navoskovaný tepaný půlblok pokrytý střední měděnkou",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Navoskované tepané schody pokryté střední měděnkou",
  "block.minecraft.waxed_weathered_lightning_rod": "Navoskovaný hromosvod se střední měděnkou",
  "block.minecraft.weathered_chiseled_copper": "Opracovaná měď se střední měděnkou",
  "block.minecraft.weathered_copper": "Měď se střední měděnkou",
  "block.minecraft.weathered_copper_bars": "Měděné mříže se střední měděnkou",
  "block.minecraft.weathered_copper_bulb": "Měděná lampa se střední měděnkou",
  "block.minecraft.weathered_copper_chain": "Měděný řetěz se střední měděnkou",
  "block.minecraft.weathered_copper_chest": "Měděná truhla se střední měděnkou",
  "block.minecraft.weathered_copper_door": "Měděné dveře se střední měděnkou",
  "block.minecraft.weathered_copper_golem_statue": "Soška měděného golema se střední měděnkou",
  "block.minecraft.weathered_copper_grate": "Měděný rošt se střední měděnkou",
  "block.minecraft.weathered_copper_lantern": "Měděná lucerna se střední měděnkou",
  "block.minecraft.weathered_copper_trapdoor": "Měděný poklop se střední měděnkou",
  "block.minecraft.weathered_cut_copper": "Tepaná měď pokrytá střední měděnkou",
  "block.minecraft.weathered_cut_copper_slab": "Tepaný půlblok pokrytý střední měděnkou",
  "block.minecraft.weathered_cut_copper_stairs": "Tepané schody pokryté střední měděnkou",
  "block.minecraft.weathered_lightning_rod": "Hromosvod se střední měděnkou",
  "block.minecraft.weeping_vines": "Karmínová liána",
  "block.minecraft.weeping_vines_plant": "Stonek karmínové liány",
  "block.minecraft.wet_sponge": "Mokrá mořská houba",
  "block.minecraft.wheat": "Pšenice",
  "block.minecraft.white_banner": "Bílý prapor",
  "block.minecraft.white_bed": "Bílá postel",
  "block.minecraft.white_candle": "Bílá svíčka",
  "block.minecraft.white_candle_cake": "Dort s bílou svíčkou",
  "block.minecraft.white_carpet": "Bílý koberec",
  "block.minecraft.white_concrete": "Bílý beton",
  "block.minecraft.white_concrete_powder": "Bílý cement",
  "block.minecraft.white_glazed_terracotta": "Bílá glazovaná terakota",
  "block.minecraft.white_shulker_box": "Bílá shulkerova schránka",
  "block.minecraft.white_stained_glass": "Bílé sklo",
  "block.minecraft.white_stained_glass_pane": "Tabulka bílého skla",
  "block.minecraft.white_terracotta": "Bílá terakota",
  "block.minecraft.white_tulip": "Bílý tulipán",
  "block.minecraft.white_wool": "Bílá vlna",
  "block.minecraft.wildflowers": "Divoké kvítí",
  "block.minecraft.wither_rose": "Witherova růže",
  "block.minecraft.wither_skeleton_skull": "Lebka wither kostlivce",
  "block.minecraft.wither_skeleton_wall_skull": "Lebka wither kostlivce na zdi",
  "block.minecraft.yellow_banner": "Žlutý prapor",
  "block.minecraft.yellow_bed": "Žlutá postel",
  "block.minecraft.yellow_candle": "Žlutá svíčka",
  "block.minecraft.yellow_candle_cake": "Dort se žlutou svíčkou",
  "block.minecraft.yellow_carpet": "Žlutý koberec",
  "block.minecraft.yellow_concrete": "Žlutý beton",
  "block.minecraft.yellow_concrete_powder": "Žlutý cement",
  "block.minecraft.yellow_glazed_terracotta": "Žlutá glazovaná terakota",
  "block.minecraft.yellow_shulker_box": "Žlutá shulkerova schránka",
  "block.minecraft.yellow_stained_glass": "Žluté sklo",
  "block.minecraft.yellow_stained_glass_pane": "Tabulka žlutého skla",
  "block.minecraft.yellow_terracotta": "Žlutá terakota",
  "block.minecraft.yellow_wool": "Žlutá vlna",
  "block.minecraft.zombie_head": "Hlava zombie",
  "block.minecraft.zombie_wall_head": "Hlava zombie na zdi",
  "item.minecraft.acacia_boat": "Akáciový člun",
  "item.minecraft.acacia_chest_boat": "Akáciový člun s truhlou",
  "item.minecraft.allay_spawn_egg": "Vajíčko s alíkem",
  "item.minecraft.amethyst_shard": "Ametystový střep",
  "item.minecraft.angler_pottery_shard": "Střep s udicí",
  "item.minecraft.angler_pottery_sherd": "Střep s udicí",
  "item.minecraft.apple": "Jablko",
  "item.minecraft.archer_pottery_shard": "Střep s lukem",
  "item.minecraft.archer_pottery_sherd": "Střep s lukem",
  "item.minecraft.armadillo_scute": "Destička pásovce",
  "item.minecraft.armadillo_spawn_egg": "Vajíčko s pásovcem",
  "item.minecraft.armor_stand": "Stojan na zbroj",
  "item.minecraft.arms_up_pottery_shard": "Střep s rukama nad hlavou",
  "item.minecraft.arms_up_pottery_sherd": "Střep s rukama nad hlavou",
  "item.minecraft.arrow": "Šíp",
  "item.minecraft.axolotl_bucket": "Kbelík s axolotlem",
  "item.minecraft.axolotl_spawn_egg": "Vajíčko s axolotlem",
  "item.minecraft.baked_potato": "Pečená brambora",
  "item.minecraft.bamboo_chest_raft": "Bambusový vor s truhlou",
  "item.minecraft.bamboo_raft": "Bambusový vor",
  "item.minecraft.bat_spawn_egg": "Vajíčko s netopýrem",
  "item.minecraft.bee_spawn_egg": "Vajíčko se včelou",
  "item.minecraft.beef": "Syrový steak",
  "item.minecraft.beetroot": "Červená řepa",
  "item.minecraft.beetroot_seeds": "Semínka červené řepy",
  "item.minecraft.beetroot_soup": "Polévka z červené řepy",
  "item.minecraft.birch_boat": "Březový člun",
  "item.minecraft.birch_chest_boat": "Březový člun s truhlou",
  "item.minecraft.black_bundle": "Černý ranec",
  "item.minecraft.black_dye": "Černé barvivo",
  "item.minecraft.black_harness": "Černý postroj",
  "item.minecraft.blade_pottery_shard": "Střep s čepelí",
  "item.minecraft.blade_pottery_sherd": "Střep s čepelí",
  "item.minecraft.blaze_powder": "Ohnivý prach",
  "item.minecraft.blaze_rod": "Ohnivá hůl",
  "item.minecraft.blaze_spawn_egg": "Vajíčko s ohnivákem",
  "item.minecraft.blue_bundle": "Modrý ranec",
  "item.minecraft.blue_dye": "Modré barvivo",
  "item.minecraft.blue_egg": "Modré vajíčko",
  "item.minecraft.blue_harness": "Modrý postroj",
  "item.minecraft.bogged_spawn_egg": "Vajíčko s bahnivcem",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornament nýtování",
  "item.minecraft.bone": "Kost",
  "item.minecraft.bone_meal": "Kostní moučka",
  "item.minecraft.book": "Kniha",
  "item.minecraft.bordure_indented_banner_pattern": "Vzor praporu s bordurou",
  "item.minecraft.bow": "Luk",
  "item.minecraft.bowl": "Miska",
  "item.minecraft.bread": "Chléb",
  "item.minecraft.breeze_rod": "Fičákova hůl",
  "item.minecraft.breeze_spawn_egg": "Vajíčko s fičákem",
  "item.minecraft.brewer_pottery_shard": "Střep s baňkou",
  "item.minecraft.brewer_pottery_sherd": "Střep s baňkou",
  "item.minecraft.brewing_stand": "Varný stojan",
  "item.minecraft.brick": "Cihla",
  "item.minecraft.brown_bundle": "Hnědý ranec",
  "item.minecraft.brown_dye": "Hnědé barvivo",
  "item.minecraft.brown_egg": "Hnědé vajíčko",
  "item.minecraft.brown_harness": "Hnědý postroj",
  "item.minecraft.brush": "Štěteček",
  "item.minecraft.bucket": "Kbelík",
  "item.minecraft.bundle": "Ranec",
  "item.minecraft.bundle.empty": "Prázdný",
  "item.minecraft.bundle.empty.description": "Může obsahovat hromadu rozličných předmětů",
  "item.minecraft.bundle.full": "Plný",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Střep s ohněm",
  "item.minecraft.burn_pottery_sherd": "Střep s ohněm",
  "item.minecraft.camel_husk_spawn_egg": "Vajíčko se zombloudem",
  "item.minecraft.camel_spawn_egg": "Vajíčko s velbloudem",
  "item.minecraft.carrot": "Mrkev",
  "item.minecraft.carrot_on_a_stick": "Mrkev na prutu",
  "item.minecraft.cat_spawn_egg": "Vajíčko s kočkou",
  "item.minecraft.cauldron": "Kotel",
  "item.minecraft.cave_spider_spawn_egg": "Vajíčko s jeskynním pavoukem",
  "item.minecraft.chainmail_boots": "Kroužkové boty",
  "item.minecraft.chainmail_chestplate": "Kroužková košile",
  "item.minecraft.chainmail_helmet": "Kroužková kapuce",
  "item.minecraft.chainmail_leggings": "Kroužkové kalhoty",
  "item.minecraft.charcoal": "Dřevěné uhlí",
  "item.minecraft.cherry_boat": "Třešňový člun",
  "item.minecraft.cherry_chest_boat": "Třešňový člun s truhlou",
  "item.minecraft.chest_minecart": "Nákladní vozík",
  "item.minecraft.chicken": "Syrové kuře",
  "item.minecraft.chicken_spawn_egg": "Vajíčko se slepicí",
  "item.minecraft.chorus_fruit": "Plod chorusu",
  "item.minecraft.clay_ball": "Hrouda jílu",
  "item.minecraft.clock": "Hodiny",
  "item.minecraft.coal": "Uhlí",
  "item.minecraft.coast_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornament pobřeží",
  "item.minecraft.cocoa_beans": "Kakaové boby",
  "item.minecraft.cod": "Syrová treska",
  "item.minecraft.cod_bucket": "Kbelík s treskou",
  "item.minecraft.cod_spawn_egg": "Vajíčko s treskou",
  "item.minecraft.command_block_minecart": "Vozík s příkazovým blokem",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Propečený steak",
  "item.minecraft.cooked_chicken": "Pečené kuře",
  "item.minecraft.cooked_cod": "Pečená treska",
  "item.minecraft.cooked_mutton": "Pečené skopové",
  "item.minecraft.cooked_porkchop": "Pečená kotleta",
  "item.minecraft.cooked_rabbit": "Pečený králík",
  "item.minecraft.cooked_salmon": "Pečený losos",
  "item.minecraft.cookie": "Sušenka",
  "item.minecraft.copper_axe": "Měděná sekera",
  "item.minecraft.copper_boots": "Měděné boty",
  "item.minecraft.copper_chestplate": "Měděné brnění",
  "item.minecraft.copper_golem_spawn_egg": "Vajíčko s měděným golemem",
  "item.minecraft.copper_helmet": "Měděná helma",
  "item.minecraft.copper_hoe": "Měděná motyka",
  "item.minecraft.copper_horse_armor": "Měděná zbroj pro koně",
  "item.minecraft.copper_ingot": "Měděný ingot",
  "item.minecraft.copper_leggings": "Měděné kalhoty",
  "item.minecraft.copper_nautilus_armor": "Měděná loděnčí zbroj",
  "item.minecraft.copper_nugget": "Měděný nuget",
  "item.minecraft.copper_pickaxe": "Měděný krumpáč",
  "item.minecraft.copper_shovel": "Měděná lopata",
  "item.minecraft.copper_spear": "Měděné kopí",
  "item.minecraft.copper_sword": "Měděný meč",
  "item.minecraft.cow_spawn_egg": "Vajíčko s krávou",
  "item.minecraft.creaking_spawn_egg": "Vajíčko se skřípotem",
  "item.minecraft.creeper_banner_pattern": "Vzor praporu",
  "item.minecraft.creeper_banner_pattern.desc": "Tvář creepera",
  "item.minecraft.creeper_banner_pattern.new": "Vzor praporu s creeperem",
  "item.minecraft.creeper_spawn_egg": "Vajíčko s creeperem",
  "item.minecraft.crossbow": "Kuše",
  "item.minecraft.crossbow.projectile": "Projektil:",
  "item.minecraft.crossbow.projectile.multiple": "Projektil: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Projektil: %s",
  "item.minecraft.cyan_bundle": "Azurový ranec",
  "item.minecraft.cyan_dye": "Azurové barvivo",
  "item.minecraft.cyan_harness": "Azurový postroj",
  "item.minecraft.danger_pottery_shard": "Střep s creeperem",
  "item.minecraft.danger_pottery_sherd": "Střep s creeperem",
  "item.minecraft.dark_oak_boat": "Člun z tmavého dubu",
  "item.minecraft.dark_oak_chest_boat": "Člun z tmavého dubu s truhlou",
  "item.minecraft.debug_stick": "Ladicí hůlka",
  "item.minecraft.debug_stick.empty": "Předmět „%s“ nemá žádné vlastnosti",
  "item.minecraft.debug_stick.select": "Vlastnosti „%s“ vybrána hodnota „%s“",
  "item.minecraft.debug_stick.update": "Vlastnost „%s“ změněna na hodnotu „%s“",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantová sekera",
  "item.minecraft.diamond_boots": "Diamantové boty",
  "item.minecraft.diamond_chestplate": "Diamantové brnění",
  "item.minecraft.diamond_helmet": "Diamantová helma",
  "item.minecraft.diamond_hoe": "Diamantová motyka",
  "item.minecraft.diamond_horse_armor": "Diamantová zbroj pro koně",
  "item.minecraft.diamond_leggings": "Diamantové kalhoty",
  "item.minecraft.diamond_nautilus_armor": "Diamantová loděnčí zbroj",
  "item.minecraft.diamond_pickaxe": "Diamantový krumpáč",
  "item.minecraft.diamond_shovel": "Diamantová lopata",
  "item.minecraft.diamond_spear": "Diamantové kopí",
  "item.minecraft.diamond_sword": "Diamantový meč",
  "item.minecraft.disc_fragment_5": "Úlomek desky",
  "item.minecraft.disc_fragment_5.desc": "Gramofonová deska - 5",
  "item.minecraft.dolphin_spawn_egg": "Vajíčko s delfínem",
  "item.minecraft.donkey_spawn_egg": "Vajíčko s oslem",
  "item.minecraft.dragon_breath": "Dračí dech",
  "item.minecraft.dried_kelp": "Sušená chaluha",
  "item.minecraft.drowned_spawn_egg": "Vajíčko s utopencem",
  "item.minecraft.dune_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornament duny",
  "item.minecraft.echo_shard": "Úlomek ozvěny",
  "item.minecraft.egg": "Vajíčko",
  "item.minecraft.elder_guardian_spawn_egg": "Vajíčko s prastrážcem",
  "item.minecraft.elytra": "Krovky",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Očarovaná kniha",
  "item.minecraft.enchanted_golden_apple": "Očarované zlaté jablko",
  "item.minecraft.end_crystal": "Endový krystal",
  "item.minecraft.ender_dragon_spawn_egg": "Vajíčko s drakem z Endu",
  "item.minecraft.ender_eye": "Endové oko",
  "item.minecraft.ender_pearl": "Endová perla",
  "item.minecraft.enderman_spawn_egg": "Vajíčko s endermanem",
  "item.minecraft.endermite_spawn_egg": "Vajíčko s endermitem",
  "item.minecraft.evoker_spawn_egg": "Vajíčko s mágem",
  "item.minecraft.experience_bottle": "Lektvar očarování",
  "item.minecraft.explorer_pottery_shard": "Střep s mapou",
  "item.minecraft.explorer_pottery_sherd": "Střep s mapou",
  "item.minecraft.eye_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornament oka",
  "item.minecraft.feather": "Pírko",
  "item.minecraft.fermented_spider_eye": "Zkvašené pavoučí oko",
  "item.minecraft.field_masoned_banner_pattern": "Vzor praporu s cihlovou vazbou",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Ohnivá koule",
  "item.minecraft.firework_rocket": "Rachejtle",
  "item.minecraft.firework_rocket.flight": "Délka letu:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Ohňostrojová hvězda",
  "item.minecraft.firework_star.black": "Černá",
  "item.minecraft.firework_star.blue": "Modrá",
  "item.minecraft.firework_star.brown": "Hnědá",
  "item.minecraft.firework_star.custom_color": "Vlastní",
  "item.minecraft.firework_star.cyan": "Azurová",
  "item.minecraft.firework_star.fade_to": "Přechod do",
  "item.minecraft.firework_star.flicker": "Jiskření",
  "item.minecraft.firework_star.gray": "Šedá",
  "item.minecraft.firework_star.green": "Zelená",
  "item.minecraft.firework_star.light_blue": "Světle modrá",
  "item.minecraft.firework_star.light_gray": "Světle šedá",
  "item.minecraft.firework_star.lime": "Světle zelená",
  "item.minecraft.firework_star.magenta": "Purpurová",
  "item.minecraft.firework_star.orange": "Oranžová",
  "item.minecraft.firework_star.pink": "Růžová",
  "item.minecraft.firework_star.purple": "Fialová",
  "item.minecraft.firework_star.red": "Červená",
  "item.minecraft.firework_star.shape": "Neznámý tvar",
  "item.minecraft.firework_star.shape.burst": "Roztržení",
  "item.minecraft.firework_star.shape.creeper": "Ve tvaru creeperovy hlavy",
  "item.minecraft.firework_star.shape.large_ball": "Velká koule",
  "item.minecraft.firework_star.shape.small_ball": "Malá koule",
  "item.minecraft.firework_star.shape.star": "Ve tvaru hvězdy",
  "item.minecraft.firework_star.trail": "Stopa",
  "item.minecraft.firework_star.white": "Bílá",
  "item.minecraft.firework_star.yellow": "Žlutá",
  "item.minecraft.fishing_rod": "Rybářský prut",
  "item.minecraft.flint": "Pazourek",
  "item.minecraft.flint_and_steel": "Křesadlo",
  "item.minecraft.flow_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornament víru",
  "item.minecraft.flow_banner_pattern": "Vzor praporu",
  "item.minecraft.flow_banner_pattern.desc": "Vír",
  "item.minecraft.flow_banner_pattern.new": "Vzor praporu s vírem",
  "item.minecraft.flow_pottery_sherd": "Střep s vírem",
  "item.minecraft.flower_banner_pattern": "Vzor praporu",
  "item.minecraft.flower_banner_pattern.desc": "Květ",
  "item.minecraft.flower_banner_pattern.new": "Vzor praporu s květem",
  "item.minecraft.flower_pot": "Květináč",
  "item.minecraft.fox_spawn_egg": "Vajíčko s liškou",
  "item.minecraft.friend_pottery_shard": "Střep s vesničanem",
  "item.minecraft.friend_pottery_sherd": "Střep s vesničanem",
  "item.minecraft.frog_spawn_egg": "Vajíčko s žábou",
  "item.minecraft.furnace_minecart": "Parní vozík",
  "item.minecraft.ghast_spawn_egg": "Vajíčko s ghastem",
  "item.minecraft.ghast_tear": "Ghastova slza",
  "item.minecraft.glass_bottle": "Lahvička",
  "item.minecraft.glistering_melon_slice": "Zlatavý kousek melounu",
  "item.minecraft.globe_banner_pattern": "Vzor praporu",
  "item.minecraft.globe_banner_pattern.desc": "Zeměkostka",
  "item.minecraft.globe_banner_pattern.new": "Vzor praporu se zeměkostkou",
  "item.minecraft.glow_berries": "Zářinky",
  "item.minecraft.glow_ink_sac": "Váček světélkujícího inkoustu",
  "item.minecraft.glow_item_frame": "Světelný rámeček",
  "item.minecraft.glow_squid_spawn_egg": "Vajíčko se světélkující chobotnicí",
  "item.minecraft.glowstone_dust": "Světlitový prášek",
  "item.minecraft.goat_horn": "Kozí roh",
  "item.minecraft.goat_spawn_egg": "Vajíčko s kozou",
  "item.minecraft.gold_ingot": "Zlatý ingot",
  "item.minecraft.gold_nugget": "Zlatý nuget",
  "item.minecraft.golden_apple": "Zlaté jablko",
  "item.minecraft.golden_axe": "Zlatá sekera",
  "item.minecraft.golden_boots": "Zlaté boty",
  "item.minecraft.golden_carrot": "Zlatá mrkev",
  "item.minecraft.golden_chestplate": "Zlaté brnění",
  "item.minecraft.golden_helmet": "Zlatá helma",
  "item.minecraft.golden_hoe": "Zlatá motyka",
  "item.minecraft.golden_horse_armor": "Zlatá zbroj pro koně",
  "item.minecraft.golden_leggings": "Zlaté kalhoty",
  "item.minecraft.golden_nautilus_armor": "Zlatá loděnčí zbroj",
  "item.minecraft.golden_pickaxe": "Zlatý krumpáč",
  "item.minecraft.golden_shovel": "Zlatá lopata",
  "item.minecraft.golden_spear": "Zlaté kopí",
  "item.minecraft.golden_sword": "Zlatý meč",
  "item.minecraft.gray_bundle": "Šedý ranec",
  "item.minecraft.gray_dye": "Šedé barvivo",
  "item.minecraft.gray_harness": "Šedý postroj",
  "item.minecraft.green_bundle": "Zelený ranec",
  "item.minecraft.green_dye": "Zelené barvivo",
  "item.minecraft.green_harness": "Zelený postroj",
  "item.minecraft.guardian_spawn_egg": "Vajíčko se strážcem",
  "item.minecraft.gunpowder": "Střelný prach",
  "item.minecraft.guster_banner_pattern": "Vzor praporu",
  "item.minecraft.guster_banner_pattern.desc": "Smršť",
  "item.minecraft.guster_banner_pattern.new": "Vzor praporu se smrští",
  "item.minecraft.guster_pottery_sherd": "Střep se smrští",
  "item.minecraft.happy_ghast_spawn_egg": "Vajíčko se šťastným ghastem",
  "item.minecraft.harness": "Postroj",
  "item.minecraft.heart_of_the_sea": "Srdce moře",
  "item.minecraft.heart_pottery_shard": "Střep se srdcem",
  "item.minecraft.heart_pottery_sherd": "Střep se srdcem",
  "item.minecraft.heartbreak_pottery_shard": "Střep se zlomeným srdcem",
  "item.minecraft.heartbreak_pottery_sherd": "Střep se zlomeným srdcem",
  "item.minecraft.hoglin_spawn_egg": "Vajíčko s hoglinem",
  "item.minecraft.honey_bottle": "Lahvička medu",
  "item.minecraft.honeycomb": "Plástev medu",
  "item.minecraft.hopper_minecart": "Vozík s násypkou",
  "item.minecraft.horse_spawn_egg": "Vajíčko s koněm",
  "item.minecraft.host_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornament hostitele",
  "item.minecraft.howl_pottery_shard": "Střep s vlkem",
  "item.minecraft.howl_pottery_sherd": "Střep s vlkem",
  "item.minecraft.husk_spawn_egg": "Vajíčko s pouštní zombie",
  "item.minecraft.ink_sac": "Váček inkoustu",
  "item.minecraft.iron_axe": "Železná sekera",
  "item.minecraft.iron_boots": "Železné boty",
  "item.minecraft.iron_chestplate": "Železné brnění",
  "item.minecraft.iron_golem_spawn_egg": "Vajíčko se železným golemem",
  "item.minecraft.iron_helmet": "Železná helma",
  "item.minecraft.iron_hoe": "Železná motyka",
  "item.minecraft.iron_horse_armor": "Železná zbroj pro koně",
  "item.minecraft.iron_ingot": "Železný ingot",
  "item.minecraft.iron_leggings": "Železné kalhoty",
  "item.minecraft.iron_nautilus_armor": "Železná loděnčí zbroj",
  "item.minecraft.iron_nugget": "Železný nuget",
  "item.minecraft.iron_pickaxe": "Železný krumpáč",
  "item.minecraft.iron_shovel": "Železná lopata",
  "item.minecraft.iron_spear": "Železné kopí",
  "item.minecraft.iron_sword": "Železný meč",
  "item.minecraft.item_frame": "Rámeček",
  "item.minecraft.jungle_boat": "Člun z tropického dřeva",
  "item.minecraft.jungle_chest_boat": "Člun z tropického dřeva s truhlou",
  "item.minecraft.knowledge_book": "Kniha vědění",
  "item.minecraft.lapis_lazuli": "Lazurit",
  "item.minecraft.lava_bucket": "Kbelík lávy",
  "item.minecraft.lead": "Vodítko",
  "item.minecraft.leather": "Kůže",
  "item.minecraft.leather_boots": "Kožené boty",
  "item.minecraft.leather_chestplate": "Kožená tunika",
  "item.minecraft.leather_helmet": "Kožená čapka",
  "item.minecraft.leather_horse_armor": "Kožená zbroj pro koně",
  "item.minecraft.leather_leggings": "Kožené kalhoty",
  "item.minecraft.light_blue_bundle": "Světle modrý ranec",
  "item.minecraft.light_blue_dye": "Světle modré barvivo",
  "item.minecraft.light_blue_harness": "Světle modrý postroj",
  "item.minecraft.light_gray_bundle": "Světle šedý ranec",
  "item.minecraft.light_gray_dye": "Světle šedé barvivo",
  "item.minecraft.light_gray_harness": "Světle šedý postroj",
  "item.minecraft.lime_bundle": "Světle zelený ranec",
  "item.minecraft.lime_dye": "Světle zelené barvivo",
  "item.minecraft.lime_harness": "Světle zelený postroj",
  "item.minecraft.lingering_potion": "Doznívající lektvar",
  "item.minecraft.lingering_potion.effect.awkward": "Doznívající běžný lektvar",
  "item.minecraft.lingering_potion.effect.empty": "Doznívající nevytvořitelný lektvar",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Doznívající lektvar ohnivzdornosti",
  "item.minecraft.lingering_potion.effect.harming": "Doznívající lektvar ublížení",
  "item.minecraft.lingering_potion.effect.healing": "Doznívající lektvar léčení",
  "item.minecraft.lingering_potion.effect.infested": "Doznívající lektvar zamoření",
  "item.minecraft.lingering_potion.effect.invisibility": "Doznívající lektvar neviditelnosti",
  "item.minecraft.lingering_potion.effect.leaping": "Doznívající lektvar skákání",
  "item.minecraft.lingering_potion.effect.levitation": "Doznívající lektvar levitace",
  "item.minecraft.lingering_potion.effect.luck": "Doznívající lektvar štěstí",
  "item.minecraft.lingering_potion.effect.mundane": "Doznívající světský lektvar",
  "item.minecraft.lingering_potion.effect.night_vision": "Doznívající lektvar vidění ve tmě",
  "item.minecraft.lingering_potion.effect.oozing": "Doznívající lektvar mokvání",
  "item.minecraft.lingering_potion.effect.poison": "Doznívající lektvar otravy",
  "item.minecraft.lingering_potion.effect.regeneration": "Doznívající lektvar regenerace",
  "item.minecraft.lingering_potion.effect.slow_falling": "Doznívající lektvar pomalého padání",
  "item.minecraft.lingering_potion.effect.slowness": "Doznívající lektvar zpomalení",
  "item.minecraft.lingering_potion.effect.strength": "Doznívající lektvar síly",
  "item.minecraft.lingering_potion.effect.swiftness": "Doznívající lektvar svižnosti",
  "item.minecraft.lingering_potion.effect.thick": "Doznívající hustý lektvar",
  "item.minecraft.lingering_potion.effect.turtle_master": "Doznívající lektvar želvího mistra",
  "item.minecraft.lingering_potion.effect.water": "Doznívající lahvička s vodou",
  "item.minecraft.lingering_potion.effect.water_breathing": "Doznívající lektvar dýchání pod vodou",
  "item.minecraft.lingering_potion.effect.weakness": "Doznívající lektvar oslabení",
  "item.minecraft.lingering_potion.effect.weaving": "Doznívající lektvar snování",
  "item.minecraft.lingering_potion.effect.wind_charged": "Doznívající lektvar nabití větrem",
  "item.minecraft.llama_spawn_egg": "Vajíčko s lamou",
  "item.minecraft.lodestone_compass": "Spárovaný kompas",
  "item.minecraft.mace": "Palcát",
  "item.minecraft.magenta_bundle": "Purpurový ranec",
  "item.minecraft.magenta_dye": "Purpurové barvivo",
  "item.minecraft.magenta_harness": "Purpurový postroj",
  "item.minecraft.magma_cream": "Lávová pěna",
  "item.minecraft.magma_cube_spawn_egg": "Vajíčko s magmaslizounem",
  "item.minecraft.mangrove_boat": "Kořenovníkový člun",
  "item.minecraft.mangrove_chest_boat": "Kořenovníkový člun s truhlou",
  "item.minecraft.map": "Prázdná mapa",
  "item.minecraft.melon_seeds": "Semínka melounu",
  "item.minecraft.melon_slice": "Kousek melounu",
  "item.minecraft.milk_bucket": "Mléko",
  "item.minecraft.minecart": "Vozík",
  "item.minecraft.miner_pottery_shard": "Střep s krumpáčem",
  "item.minecraft.miner_pottery_sherd": "Střep s krumpáčem",
  "item.minecraft.mojang_banner_pattern": "Vzor praporu",
  "item.minecraft.mojang_banner_pattern.desc": "Znak",
  "item.minecraft.mojang_banner_pattern.new": "Vzor praporu se znakem",
  "item.minecraft.mooshroom_spawn_egg": "Vajíčko s krávomůrkou",
  "item.minecraft.mourner_pottery_shard": "Střep s vartýřem",
  "item.minecraft.mourner_pottery_sherd": "Střep s vartýřem",
  "item.minecraft.mule_spawn_egg": "Vajíčko s mulou",
  "item.minecraft.mushroom_stew": "Houbová polévka",
  "item.minecraft.music_disc_11": "Gramofonová deska",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Gramofonová deska",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Gramofonová deska",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Gramofonová deska",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Gramofonová deska",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Gramofonová deska",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Gramofonová deska",
  "item.minecraft.music_disc_creator.desc": "Lena Raine – Creator",
  "item.minecraft.music_disc_creator_music_box": "Gramofonová deska",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine – Creator (hrací strojek)",
  "item.minecraft.music_disc_far": "Gramofonová deska",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Gramofonová deska",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions – Lava Chicken",
  "item.minecraft.music_disc_mall": "Gramofonová deska",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Gramofonová deska",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Gramofonová deska",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine – otherside",
  "item.minecraft.music_disc_pigstep": "Gramofonová deska",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine – Pigstep",
  "item.minecraft.music_disc_precipice": "Gramofonová deska",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof – Precipice",
  "item.minecraft.music_disc_relic": "Gramofonová deska",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Gramofonová deska",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Gramofonová deska",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Gramofonová deska",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy – Tears",
  "item.minecraft.music_disc_wait": "Gramofonová deska",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Gramofonová deska",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Syrové skopové",
  "item.minecraft.name_tag": "Jmenovka",
  "item.minecraft.nautilus_shell": "Ulita loděnky",
  "item.minecraft.nautilus_spawn_egg": "Vajíčko s loděnkou",
  "item.minecraft.nether_brick": "Netherová cihla",
  "item.minecraft.nether_star": "Netherová hvězda",
  "item.minecraft.nether_wart": "Bradavičník",
  "item.minecraft.netherite_axe": "Netheritová sekera",
  "item.minecraft.netherite_boots": "Netheritové boty",
  "item.minecraft.netherite_chestplate": "Netheritové brnění",
  "item.minecraft.netherite_helmet": "Netheritová helma",
  "item.minecraft.netherite_hoe": "Netheritová motyka",
  "item.minecraft.netherite_horse_armor": "Netheritová zbroj pro koně",
  "item.minecraft.netherite_ingot": "Netheritový ingot",
  "item.minecraft.netherite_leggings": "Netheritové kalhoty",
  "item.minecraft.netherite_nautilus_armor": "Netheritová loděnčí zbroj",
  "item.minecraft.netherite_pickaxe": "Netheritový krumpáč",
  "item.minecraft.netherite_scrap": "Netheritový plátek",
  "item.minecraft.netherite_shovel": "Netheritová lopata",
  "item.minecraft.netherite_spear": "Netheritové kopí",
  "item.minecraft.netherite_sword": "Netheritový meč",
  "item.minecraft.netherite_upgrade_smithing_template": "Kovářská předloha",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritové vylepšení",
  "item.minecraft.oak_boat": "Dubový člun",
  "item.minecraft.oak_chest_boat": "Dubový člun s truhlou",
  "item.minecraft.ocelot_spawn_egg": "Vajíčko s ocelotem",
  "item.minecraft.ominous_bottle": "Zlověstná lahvička",
  "item.minecraft.ominous_trial_key": "Zlověstný klíč klání",
  "item.minecraft.orange_bundle": "Oranžový ranec",
  "item.minecraft.orange_dye": "Oranžové barvivo",
  "item.minecraft.orange_harness": "Oranžový postroj",
  "item.minecraft.painting": "Obraz",
  "item.minecraft.pale_oak_boat": "Člun z bledého dubu",
  "item.minecraft.pale_oak_chest_boat": "Člun z bledého dubu s truhlou",
  "item.minecraft.panda_spawn_egg": "Vajíčko s pandou",
  "item.minecraft.paper": "Papír",
  "item.minecraft.parched_spawn_egg": "Vajíčko se sušinkou",
  "item.minecraft.parrot_spawn_egg": "Vajíčko s papouškem",
  "item.minecraft.phantom_membrane": "Blána přízraku",
  "item.minecraft.phantom_spawn_egg": "Vajíčko s přízrakem",
  "item.minecraft.pig_spawn_egg": "Vajíčko s prasetem",
  "item.minecraft.piglin_banner_pattern": "Vzor praporu",
  "item.minecraft.piglin_banner_pattern.desc": "Rypák",
  "item.minecraft.piglin_banner_pattern.new": "Vzor praporu s rypákem",
  "item.minecraft.piglin_brute_spawn_egg": "Vajíčko s piglinem hromotlukem",
  "item.minecraft.piglin_spawn_egg": "Vajíčko s piglinem",
  "item.minecraft.pillager_spawn_egg": "Vajíčko s nájezdníkem",
  "item.minecraft.pink_bundle": "Růžový ranec",
  "item.minecraft.pink_dye": "Růžové barvivo",
  "item.minecraft.pink_harness": "Růžový postroj",
  "item.minecraft.pitcher_plant": "Džbánovka",
  "item.minecraft.pitcher_pod": "Tobolka džbánovky",
  "item.minecraft.plenty_pottery_shard": "Střep s truhlou",
  "item.minecraft.plenty_pottery_sherd": "Střep s truhlou",
  "item.minecraft.poisonous_potato": "Jedovatá brambora",
  "item.minecraft.polar_bear_spawn_egg": "Vajíčko s ledním medvědem",
  "item.minecraft.popped_chorus_fruit": "Vypukaný květ chorusu",
  "item.minecraft.porkchop": "Syrová kotleta",
  "item.minecraft.potato": "Brambora",
  "item.minecraft.potion": "Lektvar",
  "item.minecraft.potion.effect.awkward": "Běžný lektvar",
  "item.minecraft.potion.effect.empty": "Nevytvořitelný lektvar",
  "item.minecraft.potion.effect.fire_resistance": "Lektvar ohnivzdornosti",
  "item.minecraft.potion.effect.harming": "Lektvar ublížení",
  "item.minecraft.potion.effect.healing": "Lektvar léčení",
  "item.minecraft.potion.effect.infested": "Lektvar zamoření",
  "item.minecraft.potion.effect.invisibility": "Lektvar neviditelnosti",
  "item.minecraft.potion.effect.leaping": "Lektvar skákání",
  "item.minecraft.potion.effect.levitation": "Lektvar levitace",
  "item.minecraft.potion.effect.luck": "Lektvar štěstí",
  "item.minecraft.potion.effect.mundane": "Světský lektvar",
  "item.minecraft.potion.effect.night_vision": "Lektvar vidění ve tmě",
  "item.minecraft.potion.effect.oozing": "Lektvar mokvání",
  "item.minecraft.potion.effect.poison": "Lektvar otravy",
  "item.minecraft.potion.effect.regeneration": "Lektvar regenerace",
  "item.minecraft.potion.effect.slow_falling": "Lektvar pomalého padání",
  "item.minecraft.potion.effect.slowness": "Lektvar zpomalení",
  "item.minecraft.potion.effect.strength": "Lektvar síly",
  "item.minecraft.potion.effect.swiftness": "Lektvar svižnosti",
  "item.minecraft.potion.effect.thick": "Hustý lektvar",
  "item.minecraft.potion.effect.turtle_master": "Lektvar želvího mistra",
  "item.minecraft.potion.effect.water": "Lahvička s vodou",
  "item.minecraft.potion.effect.water_breathing": "Lektvar dýchání pod vodou",
  "item.minecraft.potion.effect.weakness": "Lektvar oslabení",
  "item.minecraft.potion.effect.weaving": "Lektvar snování",
  "item.minecraft.potion.effect.wind_charged": "Lektvar nabití větrem",
  "item.minecraft.pottery_shard_archer": "Střep s lukem",
  "item.minecraft.pottery_shard_arms_up": "Střep s rukama nad hlavou",
  "item.minecraft.pottery_shard_prize": "Střep s drahokamem",
  "item.minecraft.pottery_shard_skull": "Střep s lebkou",
  "item.minecraft.powder_snow_bucket": "Kbelík s prašanem",
  "item.minecraft.prismarine_crystals": "Prismarínový krystal",
  "item.minecraft.prismarine_shard": "Prismarínový střep",
  "item.minecraft.prize_pottery_shard": "Střep s drahokamem",
  "item.minecraft.prize_pottery_sherd": "Střep s drahokamem",
  "item.minecraft.pufferfish": "Čtverzubec",
  "item.minecraft.pufferfish_bucket": "Kbelík se čtverzubcem",
  "item.minecraft.pufferfish_spawn_egg": "Vajíčko se čtverzubcem",
  "item.minecraft.pumpkin_pie": "Dýňový koláč",
  "item.minecraft.pumpkin_seeds": "Dýňová semínka",
  "item.minecraft.purple_bundle": "Fialový ranec",
  "item.minecraft.purple_dye": "Fialové barvivo",
  "item.minecraft.purple_harness": "Fialový postroj",
  "item.minecraft.quartz": "Netherový křemen",
  "item.minecraft.rabbit": "Syrový králík",
  "item.minecraft.rabbit_foot": "Králičí pacička",
  "item.minecraft.rabbit_hide": "Králičí kůže",
  "item.minecraft.rabbit_spawn_egg": "Vajíčko s králíkem",
  "item.minecraft.rabbit_stew": "Králičí guláš",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ornament pěstitele",
  "item.minecraft.ravager_spawn_egg": "Vajíčko s ničitelem",
  "item.minecraft.raw_copper": "Vytěžená měď",
  "item.minecraft.raw_gold": "Vytěžené zlato",
  "item.minecraft.raw_iron": "Vytěžené železo",
  "item.minecraft.recovery_compass": "Kompas návratu",
  "item.minecraft.red_bundle": "Červený ranec",
  "item.minecraft.red_dye": "Červené barvivo",
  "item.minecraft.red_harness": "Červený postroj",
  "item.minecraft.redstone": "Redstonový prášek",
  "item.minecraft.resin_brick": "Cihla z pryskyřice",
  "item.minecraft.resin_clump": "Hrudka pryskyřice",
  "item.minecraft.rib_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ornament žebra",
  "item.minecraft.rotten_flesh": "Shnilé maso",
  "item.minecraft.saddle": "Sedlo",
  "item.minecraft.salmon": "Syrový losos",
  "item.minecraft.salmon_bucket": "Kbelík s lososem",
  "item.minecraft.salmon_spawn_egg": "Vajíčko s lososem",
  "item.minecraft.scrape_pottery_sherd": "Střep se sekerou",
  "item.minecraft.scute": "Destička",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ornament stráže",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ornament utvářeče",
  "item.minecraft.sheaf_pottery_shard": "Střep se snopem",
  "item.minecraft.sheaf_pottery_sherd": "Střep se snopem",
  "item.minecraft.shears": "Nůžky",
  "item.minecraft.sheep_spawn_egg": "Vajíčko s ovcí",
  "item.minecraft.shelter_pottery_shard": "Střep se stromem",
  "item.minecraft.shelter_pottery_sherd": "Střep se stromem",
  "item.minecraft.shield": "Štít",
  "item.minecraft.shield.black": "Černý štít",
  "item.minecraft.shield.blue": "Modrý štít",
  "item.minecraft.shield.brown": "Hnědý štít",
  "item.minecraft.shield.cyan": "Azurový štít",
  "item.minecraft.shield.gray": "Šedý štít",
  "item.minecraft.shield.green": "Zelený štít",
  "item.minecraft.shield.light_blue": "Světle modrý štít",
  "item.minecraft.shield.light_gray": "Světle šedý štít",
  "item.minecraft.shield.lime": "Světle zelený štít",
  "item.minecraft.shield.magenta": "Purpurový štít",
  "item.minecraft.shield.orange": "Oranžový štít",
  "item.minecraft.shield.pink": "Růžový štít",
  "item.minecraft.shield.purple": "Fialový štít",
  "item.minecraft.shield.red": "Červený štít",
  "item.minecraft.shield.white": "Bílý štít",
  "item.minecraft.shield.yellow": "Žlutý štít",
  "item.minecraft.shulker_shell": "Shulkerův krunýř",
  "item.minecraft.shulker_spawn_egg": "Vajíčko se shulkerem",
  "item.minecraft.sign": "Cedule",
  "item.minecraft.silence_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ornament ticha",
  "item.minecraft.silverfish_spawn_egg": "Vajíčko s rybenkou",
  "item.minecraft.skeleton_horse_spawn_egg": "Vajíčko s koňským kostlivcem",
  "item.minecraft.skeleton_spawn_egg": "Vajíčko s kostlivcem",
  "item.minecraft.skull_banner_pattern": "Vzor praporu",
  "item.minecraft.skull_banner_pattern.desc": "Lebka",
  "item.minecraft.skull_banner_pattern.new": "Vzor praporu s lebkou",
  "item.minecraft.skull_pottery_shard": "Střep s lebkou",
  "item.minecraft.skull_pottery_sherd": "Střep s lebkou",
  "item.minecraft.slime_ball": "Sliz",
  "item.minecraft.slime_spawn_egg": "Vajíčko se slizounem",
  "item.minecraft.smithing_template": "Kovářská předloha",
  "item.minecraft.smithing_template.applies_to": "Lze použít na:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Přidej ingot nebo krystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Zbroj",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Přidej část zbroje",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingoty a krystaly",
  "item.minecraft.smithing_template.ingredients": "Přísady:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Přidej netheritový ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantové vybavení",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Přidej diamantovou zbroj, zbraň nebo nástroj",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritový ingot",
  "item.minecraft.smithing_template.upgrade": "Vylepšení: ",
  "item.minecraft.sniffer_spawn_egg": "Vajíčko se čmuchalem",
  "item.minecraft.snort_pottery_shard": "Střep s čmuchalem",
  "item.minecraft.snort_pottery_sherd": "Střep s čmuchalem",
  "item.minecraft.snout_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ornament rypáku",
  "item.minecraft.snow_golem_spawn_egg": "Vajíčko se sněhulákem",
  "item.minecraft.snowball": "Sněhová koule",
  "item.minecraft.spectral_arrow": "Přízračný šíp",
  "item.minecraft.spider_eye": "Pavoučí oko",
  "item.minecraft.spider_spawn_egg": "Vajíčko s pavoukem",
  "item.minecraft.spire_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ornament věže",
  "item.minecraft.splash_potion": "Vrhací lektvar",
  "item.minecraft.splash_potion.effect.awkward": "Vrhací běžný lektvar",
  "item.minecraft.splash_potion.effect.empty": "Vrhací nevytvořitelný lektvar",
  "item.minecraft.splash_potion.effect.fire_resistance": "Vrhací lektvar ohnivzdornosti",
  "item.minecraft.splash_potion.effect.harming": "Vrhací lektvar ublížení",
  "item.minecraft.splash_potion.effect.healing": "Vrhací lektvar léčení",
  "item.minecraft.splash_potion.effect.infested": "Vrhací lektvar zamoření",
  "item.minecraft.splash_potion.effect.invisibility": "Vrhací lektvar neviditelnosti",
  "item.minecraft.splash_potion.effect.leaping": "Vrhací lektvar skákání",
  "item.minecraft.splash_potion.effect.levitation": "Vrhací lektvar levitace",
  "item.minecraft.splash_potion.effect.luck": "Vrhací lektvar štěstí",
  "item.minecraft.splash_potion.effect.mundane": "Vrhací světský lektvar",
  "item.minecraft.splash_potion.effect.night_vision": "Vrhací lektvar vidění ve tmě",
  "item.minecraft.splash_potion.effect.oozing": "Vrhací lektvar mokvání",
  "item.minecraft.splash_potion.effect.poison": "Vrhací lektvar otravy",
  "item.minecraft.splash_potion.effect.regeneration": "Vrhací lektvar regenerace",
  "item.minecraft.splash_potion.effect.slow_falling": "Vrhací lektvar pomalého padání",
  "item.minecraft.splash_potion.effect.slowness": "Vrhací lektvar zpomalení",
  "item.minecraft.splash_potion.effect.strength": "Vrhací lektvar síly",
  "item.minecraft.splash_potion.effect.swiftness": "Vrhací lektvar svižnosti",
  "item.minecraft.splash_potion.effect.thick": "Vrhací hustý lektvar",
  "item.minecraft.splash_potion.effect.turtle_master": "Vrhací lektvar želvího mistra",
  "item.minecraft.splash_potion.effect.water": "Vrhací lahvička s vodou",
  "item.minecraft.splash_potion.effect.water_breathing": "Vrhací lektvar dýchání pod vodou",
  "item.minecraft.splash_potion.effect.weakness": "Vrhací lektvar oslabení",
  "item.minecraft.splash_potion.effect.weaving": "Vrhací lektvar snování",
  "item.minecraft.splash_potion.effect.wind_charged": "Vrhací lektvar nabití větrem",
  "item.minecraft.spruce_boat": "Smrkový člun",
  "item.minecraft.spruce_chest_boat": "Smrkový člun s truhlou",
  "item.minecraft.spyglass": "Dalekohled",
  "item.minecraft.squid_spawn_egg": "Vajíčko s chobotnicí",
  "item.minecraft.stick": "Tyčka",
  "item.minecraft.stone_axe": "Kamenná sekera",
  "item.minecraft.stone_hoe": "Kamenná motyka",
  "item.minecraft.stone_pickaxe": "Kamenný krumpáč",
  "item.minecraft.stone_shovel": "Kamenná lopata",
  "item.minecraft.stone_spear": "Kamenné kopí",
  "item.minecraft.stone_sword": "Kamenný meč",
  "item.minecraft.stray_spawn_egg": "Vajíčko s tulákem",
  "item.minecraft.strider_spawn_egg": "Vajíčko s lávouchem",
  "item.minecraft.string": "Vlákno",
  "item.minecraft.sugar": "Cukr",
  "item.minecraft.suspicious_stew": "Nevábná šlichta",
  "item.minecraft.sweet_berries": "Sladké bobule",
  "item.minecraft.tadpole_bucket": "Kbelík s pulcem",
  "item.minecraft.tadpole_spawn_egg": "Vajíčko s pulcem",
  "item.minecraft.tide_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ornament přílivu",
  "item.minecraft.tipped_arrow": "Namočený šíp",
  "item.minecraft.tipped_arrow.effect.awkward": "Namočený šíp",
  "item.minecraft.tipped_arrow.effect.empty": "Nevytvořitelný namočený šíp",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Šíp ohnivzdornosti",
  "item.minecraft.tipped_arrow.effect.harming": "Šíp ublížení",
  "item.minecraft.tipped_arrow.effect.healing": "Šíp léčení",
  "item.minecraft.tipped_arrow.effect.infested": "Šíp zamoření",
  "item.minecraft.tipped_arrow.effect.invisibility": "Šíp neviditelnosti",
  "item.minecraft.tipped_arrow.effect.leaping": "Šíp skákání",
  "item.minecraft.tipped_arrow.effect.levitation": "Šíp levitace",
  "item.minecraft.tipped_arrow.effect.luck": "Šíp štěstí",
  "item.minecraft.tipped_arrow.effect.mundane": "Namočený šíp",
  "item.minecraft.tipped_arrow.effect.night_vision": "Šíp vidění ve tmě",
  "item.minecraft.tipped_arrow.effect.oozing": "Šíp mokvání",
  "item.minecraft.tipped_arrow.effect.poison": "Otrávený šíp",
  "item.minecraft.tipped_arrow.effect.regeneration": "Šíp regenerace",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Šíp snášení se",
  "item.minecraft.tipped_arrow.effect.slowness": "Šíp zpomalení",
  "item.minecraft.tipped_arrow.effect.strength": "Šíp síly",
  "item.minecraft.tipped_arrow.effect.swiftness": "Šíp svižnosti",
  "item.minecraft.tipped_arrow.effect.thick": "Namočený šíp",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Šíp želvího mistra",
  "item.minecraft.tipped_arrow.effect.water": "Namočený šíp",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Šíp dýchání pod vodou",
  "item.minecraft.tipped_arrow.effect.weakness": "Šíp oslabení",
  "item.minecraft.tipped_arrow.effect.weaving": "Šíp snování",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Šíp nabití větrem",
  "item.minecraft.tnt_minecart": "Vozík s TNT",
  "item.minecraft.torchflower_seeds": "Semínka plamněnky",
  "item.minecraft.totem_of_undying": "Totem nesmrtelnosti",
  "item.minecraft.trader_llama_spawn_egg": "Vajíčko s obchodníkovou lamou",
  "item.minecraft.trial_key": "Klíč klání",
  "item.minecraft.trident": "Trojzubec",
  "item.minecraft.tropical_fish": "Tropická ryba",
  "item.minecraft.tropical_fish_bucket": "Kbelík s tropickou rybou",
  "item.minecraft.tropical_fish_spawn_egg": "Vajíčko s tropickou rybou",
  "item.minecraft.turtle_helmet": "Helma z želvoviny",
  "item.minecraft.turtle_scute": "Želví destička",
  "item.minecraft.turtle_spawn_egg": "Vajíčko se želvou",
  "item.minecraft.vex_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornament protivy",
  "item.minecraft.vex_spawn_egg": "Vajíčko s protivou",
  "item.minecraft.villager_spawn_egg": "Vajíčko s vesničanem",
  "item.minecraft.vindicator_spawn_egg": "Vajíčko se mstitelem",
  "item.minecraft.wandering_trader_spawn_egg": "Vajíčko s potulným obchodníkem",
  "item.minecraft.ward_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornament varty",
  "item.minecraft.warden_spawn_egg": "Vajíčko s vartýřem",
  "item.minecraft.warped_fungus_on_a_stick": "Přízračná houba na udici",
  "item.minecraft.water_bucket": "Kbelík vody",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornament průvodce",
  "item.minecraft.wheat": "Pšenice",
  "item.minecraft.wheat_seeds": "Semínka pšenice",
  "item.minecraft.white_bundle": "Bílý ranec",
  "item.minecraft.white_dye": "Bílé barvivo",
  "item.minecraft.white_harness": "Bílý postroj",
  "item.minecraft.wild_armor_trim_smithing_template": "Kovářská předloha",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ornament divočiny",
  "item.minecraft.wind_charge": "Větrný náboj",
  "item.minecraft.witch_spawn_egg": "Vajíčko s čarodějnicí",
  "item.minecraft.wither_skeleton_spawn_egg": "Vajíčko s wither kostlivcem",
  "item.minecraft.wither_spawn_egg": "Vajíčko s witherem",
  "item.minecraft.wolf_armor": "Vlčí brnění",
  "item.minecraft.wolf_spawn_egg": "Vajíčko s vlkem",
  "item.minecraft.wooden_axe": "Dřevěná sekera",
  "item.minecraft.wooden_hoe": "Dřevěná motyka",
  "item.minecraft.wooden_pickaxe": "Dřevěný krumpáč",
  "item.minecraft.wooden_shovel": "Dřevěná lopata",
  "item.minecraft.wooden_spear": "Dřevěné kopí",
  "item.minecraft.wooden_sword": "Dřevěný meč",
  "item.minecraft.writable_book": "Rozepsaná kniha s brkem",
  "item.minecraft.written_book": "Napsaná kniha",
  "item.minecraft.yellow_bundle": "Žlutý ranec",
  "item.minecraft.yellow_dye": "Žluté barvivo",
  "item.minecraft.yellow_harness": "Žlutý postroj",
  "item.minecraft.zoglin_spawn_egg": "Vajíčko se zoglinem",
  "item.minecraft.zombie_horse_spawn_egg": "Vajíčko se zombie koněm",
  "item.minecraft.zombie_nautilus_spawn_egg": "Vajíčko se zombie loděnkou",
  "item.minecraft.zombie_spawn_egg": "Vajíčko se zombie",
  "item.minecraft.zombie_villager_spawn_egg": "Vajíčko se zombie vesničanem",
  "item.minecraft.zombified_piglin_spawn_egg": "Vajíčko se zombie piglinem"
}
export const cs_cz = items; 
